var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _path, _path2, _use, _path3, _path4, _symbol7, _path5, _path6, _path7, _path8, _symbol8, _path9, _path10, _path11, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _use2, _symbol14, _use3, _symbol15, _use4, _symbol16, _use5, _path12, _path13, _path14, _path15, _path16, _path17, _use6, _symbol17, _use7, _path18, _path19, _path20, _path21, _path22, _use8, _path23, _path24, _path25, _path26, _path27, _use9, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _use10, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _use11, _symbol18, _use12, _path50, _path51, _g, _use13, _symbol19, _use14, _symbol20, _use15, _path52, _path53, _polygon, _path54, _path55, _polygon2, _use16, _symbol21, _symbol22, _symbol23, _path56, _path57, _use17, _use18, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _view, _view2, _view3, _view4, _view5, _view6, _view7, _view8, _view9, _view10, _view11, _view12, _view13, _view14, _view15, _view16, _view17, _view18, _view19, _view20, _view21, _view22, _view23, _view24, _view25, _view26, _view27, _view28, _view29, _view30, _view31, _view32, _view33, _view34, _view35, _view36, _view37, _view38, _view39, _view40, _view41, _view42, _view43, _view44, _view45, _view46, _view47, _view48, _view49, _view50, _view51, _view52, _view53, _view54, _view55, _view56, _view57, _view58, _view59, _view60, _view61, _view62, _view63, _view64, _view65, _view66, _view67, _view68, _view69, _view70, _view71, _view72, _view73, _view74, _view75, _view76, _view77, _view78, _view79, _view80, _view81, _view82, _view83, _view84, _view85, _view86, _view87, _view88, _view89, _view90, _view91, _view92, _view93, _view94, _view95, _view96, _view97, _view98, _view99, _view100, _view101, _view102, _view103, _view104, _view105, _view106, _view107, _view108, _view109, _view110, _view111, _view112, _view113, _view114, _view115, _view116, _view117, _view118, _view119, _view120, _view121, _view122, _view123, _view124, _view125, _view126, _view127, _view128, _view129, _view130, _view131;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gr1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#add36c",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5fb43b",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#008f00",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 62
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#add36c",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5fb43b",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#008f00",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4e8b3",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#add36c",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ye1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#FCCA02",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#F5AB00",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#DB8400",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ye2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#E9DEB4",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#FCCA02",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "re1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d36c6c",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b43b3b",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f0000",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "re2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8b3b3",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d36c6c",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "vi1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d7de8",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#835ce6",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6748a9",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 62
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d7de8",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#835ce6",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6748a9",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d1fa",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d7de8",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bl1",
    gradientUnits: "userSpaceOnUse",
    cx: 32,
    cy: 32,
    dx: 32,
    dy: 61,
    r: 28
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adadff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939cff",
      stopOpacity: 1
    },
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7980ff",
      stopOpacity: 1
    },
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl2",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 25
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3f1ff",
      stopOpacity: 1
    },
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adbdff",
      stopOpacity: 1
    },
    offset: "100%"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "cancel",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,56c-4-2-7-5-11-8c-5-5-9-9-13-15 c4-6,8-10,13-15c3-3,7-6,11-8c1-1,10-5,7-6 c-12-4-27,7-37,16C21,10,12-2,5,2C-4,8,7,23,15,33 C7,43-4,59,5,64c7,4,16-8,22-18c10,9,25,20,37,16 C67,61,58,57,57,56z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "ok",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,30c-0,0-0,0-1,1c2-3,5-6,8-9c3-3,6-6,9-8c2-1,3-2,5-3c1-1,2-1,2-1C63,8,64,8,64,7c0-2-6-1-7-1c0,0,1-0,1-0c-1,0-1,0-1,0c1,0,1-0,2-0c-2,0-4,1-5,1c-2,1-4,2-6,3c-4,3-8,6-12,9c-4,3-7,7-11,11 c-2,2-3,4-5,6C20,36,19,38,18,38c-1-0-1-2-1-3c-0-1-1-2-1-3c-1-2-2-4-4-4c-4-2-8-1-11,2c-1,2-2,4-1,5c0,2,2,4,3,6c1,2,2,5,3,7c1,2,2,4,3,6c2,2,3,4,6,4c1,0,3-0,4-1c1-1,2-2,3-3c4-5,7-11,11-17L39,30z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "_empty",
    viewBox: "0 0 64 64"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "_menu",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4,19.5h32.9c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3H16.4c-1.7,0-3,1.3-3,3C13.3,18.2,14.7,19.5,16.4,19.5z M49.2,29.9H16.3             c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3h32.9c1.7,0,3-1.3,3-3C52.2,31.2,50.9,29.9,49.2,29.9z M49.2,46.2H16.3c-1.7,0-3,1.3-3,3             s1.3,3,3,3h32.9c1.7,0,3-1.3,3-3C52.2,47.6,50.9,46.2,49.2,46.2z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "_log",
    viewBox: "-24 -16 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4,64C5.1,64,0,58.9,0,52.6V11.4C0,5.1,5.1,0,11.4,0h23.5c6.3,0,11.4,5.1,11.4,11.4v4.7c0,2.4-1.9,4.3-4.3,4.3 c-2.4,0-4.3-1.9-4.3-4.3v-4.7c0-1.5-1.2-2.7-2.7-2.7H11.4c-1.5,0-2.7,1.2-2.7,2.7v41.3c0,1.5,1.2,2.7,2.7,2.7h23.5 c1.5,0,2.7-1.2,2.7-2.7v-4.7c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v4.7c0,6.3-5.1,11.4-11.4,11.4H11.4z M53.4,44.2 c-1.2,0-2.3-0.5-3.1-1.3c-0.8-0.8-1.3-2-1.3-3.2c0-1.1,0.5-2.2,1.3-2.9l0.3-0.3H27.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3 h23.3l-0.3-0.3c-0.8-0.8-1.3-2-1.3-3.2c0-1.1,0.5-2.2,1.3-2.9c0.8-0.8,1.9-1.3,3.1-1.3c1.2,0,2.3,0.5,3.1,1.3l5.2,5.2 c3.1,3.1,3.1,8,0.1,11.1l-5.3,5.3C55.7,43.7,54.6,44.2,53.4,44.2z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "selec",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 1,
    points: "34 5,50 5,50 16,61 16,61 32,50 32,50 43,34 43,34 32,23 32,23 16,34 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 1,
    points: "14 21,30 21,30 32,41 32,41 48,30 48,30 59,14 59,14 48,3 48,3 32,14 32"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#gr1)"
    },
    stroke: "#008f00",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#gr2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 1,
    points: "26 13,38 13,38 26,51 26,51 38,38 38,38 51,26 51,26 38,13 38,13 26,26 26"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#gr1)"
    },
    stroke: "#008f00",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#gr2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 1,
    d: "M18,19c-1.8,0-3.2,1.4-3.2,3.2v20.9c0,1.8,1.4,3.2,3.2,3.2h29.3c1.8,0,3.2-1.4,3.2-3.2l-0.1-17.4 c0-1.8-1.4-3.2-3.2-3.2H29.1l-2.9-3.4c-0.1-0.1-0.2-0.2-0.4-0.2H14.3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#ye1)"
    },
    stroke: "#DB8400",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#ye2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M45.9,14.2c4.5,3.4,2.4,6.3,2.4,6.3l-9.6-7.2C38.6,13.3,40.8,10.4,45.9,14.2z M44.7,25.3l-9.6-7.2l1.5-2l9.6,7.2L44.7,25.3z             M19.7,48.8c-0.2-0.1-0.8,0.3-0.8,0.3l-0.6,0.8L18,41.6l3.8-0.9l0.5,4.7l4.7-0.9l0.2,3.9L19,50.5l0.6-0.8             C19.6,49.7,19.8,48.9,19.7,48.8z M27.4,44.3l13.2-17.6c0,0,0.2-0.5,0.1-0.6c-0.1-0.1-0.5,0.3-0.5,0.3L27,44l-4.2,0.6l-0.6-4.2             l13.2-17.6c0,0,0.2-0.4,0.1-0.5c-0.1-0.1-0.5,0.2-0.5,0.2L21.8,40.1L18,41l16.7-22.4l9.6,7.2L27.6,48.2L27.4,44.3z M46.5,22.9             l-9.6-7.2l1.5-2l9.6,7.2L46.5,22.9z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#ye1)"
    },
    stroke: "#DB8400",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#ye2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M51.1,40.4c0,1.4-0.6,1.9-1.9,1.9H30.4c-1.4,0-1.9-0.9-1.9-1.9V14.6c0-1.1,0.5-1.9,1.9-1.9h11.3V22h9.4V40.4z M51.1,21.4 h-8.7v-8.7h0.5l8.2,8.2V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M37.1,48.4c0,1.4-0.6,1.9-1.9,1.9H16.4c-1.4,0-1.9-0.9-1.9-1.9V22.6c0-1.1,0.5-1.9,1.9-1.9h11.3V30h9.4V48.4z M37.1,29.4 h-8.7v-8.7h0.5l8.2,8.2V29.4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "del",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#re1)"
    },
    stroke: "#8f0000",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#re2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 2,
    strokeOpacity: 0.7,
    width: 38,
    height: 38,
    x: 13,
    y: 13
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "del2",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    width: 56,
    height: 56,
    x: 4,
    y: 4
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "filt",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M13,20.2v2.4c0,0.7-0.1,1.4,0.5,1.8l14.2,13.5c0.8,0.7,1.3,1.8,1.3,2.8v11.4l7-4.1v-7.3c0-1,0.5-2.1,1.2-2.8l14.1-13.4             c0.5-0.5,0.5-1.1,0.5-1.8V20C48.4,22.2,40.4,24,32.3,24C24.2,23.9,16.2,22.5,13,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M32.1,14.3c-11.9,0.1-19.3,2.8-19.3,4.7c0,1.8,7.4,4.5,19.3,4.5c11.9,0,19.3-2.6,19.3-4.5C51.5,17.1,44.1,14.4,32.1,14.3             L32.1,14.3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "fold",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M21.6,14c-1.8,0-3.2,1.4-3.2,3.2v20.9c0,1.8,1.4,3.2,3.2,3.2h29.3c1.8,0,3.2-1.4,3.2-3.2l-0.1-17.4c0-1.8-1.4-3.2-3.2-3.2 H36.5l-2.9-3.4c-0.1-0.1-0.2-0.2-0.4-0.2H21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M14.3,19.7c-1.8,0-3.2,1.4-3.2,3.2v20.9c0,1.8,1.4,3.2,3.2,3.2h29.3c1.8,0,3.2-1.4,3.2-3.2l-0.1-17.4 c0-1.8-1.4-3.2-3.2-3.2H29.1l-2.9-3.4c-0.1-0.1-0.2-0.2-0.4-0.2H14.3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "unfold",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M19.9,19.2h-0.2c-2.2,0-4,1.8-4,4s1.8,4,4,4h0.2c2.2,0,4-1.8,4-4S22.2,19.2,19.9,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M46.7,19.2H31.5c-2.2,0-4,1.8-4,4s1.8,4,4,4h15.2c2.2,0,4-1.8,4-4S49,19.2,46.7,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M19.9,30h-0.2c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4h0.2c2.2,0,4-1.8,4-4C24,31.8,22.2,30,19.9,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M46.7,30H31.5c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4h15.2c2.2,0,4-1.8,4-4C50.8,31.8,49,30,46.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M19.9,40.7h-0.2c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4h0.2c2.2,0,4-1.8,4-4C24,42.5,22.2,40.7,19.9,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M46.7,40.7H31.5c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4h15.2c2.2,0,4-1.8,4-4C50.8,42.5,49,40.7,46.7,40.7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "post",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M41,46.8c0,1.6-0.7,2.2-2.2,2.2H17.2             c-1.6,0-2.2-1-2.2-2.2V17.2c0-1.3,0.6-2.2,2.2-2.2h13v10.7H41V46.8z M41,25H31V15h0.6l9.4,9.4V25z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    style: {
      fill: "#a9ec76"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    width: 36,
    height: 36,
    x: 20,
    y: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "unpost",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M41,46.8c0,1.6-0.7,2.2-2.2,2.2H17.2             c-1.6,0-2.2-1-2.2-2.2V17.2c0-1.3,0.6-2.2,2.2-2.2h13v10.7H41V46.8z M41,25H31V15h0.6l9.4,9.4V25z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#f1644b"
    },
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    width: 32,
    height: 32,
    x: 20,
    y: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "print_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print1",
    width: 40,
    height: 40,
    x: 12,
    y: 10
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "input_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M41,46.8c0,1.6-0.7,2.2-2.2,2.2H17.2             c-1.6,0-2.2-1-2.2-2.2V17.2c0-1.3,0.6-2.2,2.2-2.2h13v10.7H41V46.8z M41,25H31V15h0.6l9.4,9.4V25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a9ec76",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M57.3,36L44,23v7H27v14h17v7L57.3,36z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "transact_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2,47c0-0.6,0-1.1,0-1.6c-6.8,0-9.8-2.9-14.3-7.6c-3.4-3.5-8.3-11.2-13.7-11.2             l-0.2,0c-0.1,0-0.2,0-0.3,0c0,0.6,0.1,1.2,0.1,1.8l0,0.7v2.2L14.1,28c-1.8-1.5-3.5-3-5.2-4.5L8,22.8L8.9,22c1.7-1.4,3.3-2.8,5-4.3             l4-3.5v2.2c0,0.8,0,1.5,0,2.3c6.9,0.3,9.7,3.3,14.4,8c3.7,3.7,8.2,11,14,10.5c0-0.7,0-1.5,0-2.2v-2.2l1.6,1.4             c2.6,2.2,4.9,4.2,7.3,6.3l0.9,0.8L55.1,42c-2.4,2.1-4.7,4.1-7.3,6.3l-1.7,1.4L46.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,40c-3.1,4.1-7.1,6.3-12.3,5.8v4.5L8,41.8l1.8-1.6c2.1-1.8,4.2-3.6,6.4-5.5             l1.7-1.4v2.2c0,0.8,0,1.6,0,2.4c3.3,0.3,4.7-1.4,6.6-3.7l0.3-0.4L30.1,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4,24.2c3.1-4.4,7.6-6,12.8-5.4v-4.6l1.7,1.4c1.9,1.6,3.6,3.1,5.4,4.6l2.8,2.4             l-0.9,0.8c-2.4,2.1-4.7,4.1-7.3,6.3l-1.7,1.4V29c0-0.7,0.1-1.4,0.1-2.2c-2.8-1.2-5.3,1.5-7.1,3.2L33.4,24.2z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "check_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M43.8,14H20.2c-3.3,0-6,2.7-6,6v24c0,3.3,2.7,6,6,6h23.7c3.3,0,6-2.7,6-6V20C49.8,16.7,47.1,14,43.8,14z M28.2,44.7 l-11-11.8l5-5.3L28,34l14.3-15.5l4.7,4.8L28.2,44.7z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "uncheck_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M49.8,44c0,3.3-2.7,6-6,6H20.2c-3.3,0-6-2.7-6-6V20c0-3.3,2.7-6,6-6h23.7c3.3,0,6,2.7,6,6V44z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "up_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M24,51V31H12l20-19l20,19H40v20H24z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "dn_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M40,12v20h12L32,51L12,32h12V12H40z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "his_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_402",
    width: 60,
    height: 60,
    x: 2,
    y: 2
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "refr",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi1)"
    },
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#vi2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M43.5,32.9C43,38.9,38.1,43.5,32,43.5c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6             c2.5,0,4.7,0.8,6.6,2.1l-3.6,4H49l-3.4-13.9l-3.1,4.7c-3-2.1-6.6-3.4-10.5-3.4C22,14,14,22,14,32S22,50,32,50             c9.6,0,17.5-7.6,18-17.1H43.5z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "inf",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#bl1)"
    },
    stroke: "#7980ff",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M61 32C61 48.01 48 61 32 61C15.99 61 3 48.01 3 32C3 16 15.99 3 32 3C48 3 61 16 61 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#bl2)"
    },
    d: "M53 19C53 27 44 33 32 33C20 33 11 27 11 19C11 11 20 5 32 5C43 5 53 11 53 19Z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M22.4,55.1c-2.1,0-4.3-1.7-4.1-4c0.3-2.5,3.1-3.3,5.1-3.7c3.2-0.6,2.8-5.2,3.5-8.3c0.7-2.9,1.7-5.7,2.2-8.6 c-2.5,0.8-11,2.4-9.1-3.2c1-2.9,6.1-3.4,8.5-3.8c4-0.5,10.8-1.2,10.8,4.7c0,4.4-2.5,8.8-3.6,12.9c-1,3.5-1.6,5.2,2,5.9 c2.1,0.4,6.3,0.9,7.3,3.3c1.9,4.9-6.2,3.7-8.4,3.2C31.6,52.8,27.3,55.1,22.4,55.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    d: "M36.3,18.4c-6,0-6.3-8.9-0.8-10.2C43.1,6.5,44,18.4,36.3,18.4z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "calen",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4,13.3c1.4,0,2.6,1.2,2.6,2.6v33.5c0,1.4-1.1,2.6-2.6,2.6H18.6c-1.4,0-2.6-1.2-2.6-2.6V15.9             c0-1.4,1.1-2.6,2.6-2.6h3.3v4.4c0,1.6,2.3,2.9,3.9,2.9h0.6c1.6,0,3.9-1.3,3.9-2.9v-4.4h11.9v4.4c0,1.6,2.3,2.9,3.9,2.9h0.6             c1.6,0,3.8-0.9,3.8-2.5v-4.8H53.4z M51.4,24.6H20.6v22.8h30.8V24.6z M25.8,18.9c-0.9,0-2.1-0.7-2.1-1.6v-5.6c0-0.9,1.2-1.6,2.1-1.6             h0.6c0.9,0,2.1,0.7,2.1,1.6v5.6c0,0.9-1.2,1.6-2.1,1.6H25.8z M43.9,11.7c0-0.9,1.2-1.6,2.1-1.6h0.6c0.9,0,2.1,0.7,2.1,1.6v5.6             c0,0.9-1.2,1.6-2.1,1.6H46c-0.9,0-2.1-0.7-2.1-1.6V11.7z M37.6,31.6c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H37.6z M44.6,31.6c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H44.6z M23.6,38.2c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H23.6z M30.6,38.2c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H30.6z M37.6,38.2c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H37.6z M44.6,38.2c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3h3.9             c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3H44.6z M27.4,40.2c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3h-3.9             c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3H27.4z M34.4,40.2c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3h-3.9             c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3H34.4z M41.4,40.2c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3h-3.9             c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3H41.4z M48.4,40.2c0.2,0,0.3,0.2,0.3,0.3v4.1c0,0.2-0.2,0.3-0.3,0.3h-3.9             c-0.2,0-0.3-0.2-0.3-0.3l0,0v-4.1c0-0.2,0.2-0.3,0.3-0.3H48.4z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "run_",
    viewBox: "0 0 32 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a9ec76"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 1,
    points: "4 2,30 28,4 54"
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "exmark",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M49,37.5L49,37.5C48.9,37.6,49,37.6,49,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,55.3c-0.7,0-1.3-0.3-1.7-0.8c0,0,0-0.1-0.1-0.1L3,42.1c-0.5-0.9-0.3-2.1,0.6-2.7C4,39.1,14,31.2,17.4,29         c3-1.8,7.5-3.5,12-5c3.6-1.3,7.1-2.6,9.4-3.8c2.7-1.4,9.6-7.4,9.7-7.5c0,0,0.1-0.1,0.1-0.1c0.3-0.2,0.7-0.3,1-0.3         c0.6,0,1.2,0.3,1.6,0.8c0.7,0.7,2.7,2.6,3.2,3.6c0.3,0.7,0.4,1.6,0.6,2.5c0.2,1.2,0.5,2.6,0.9,3.3c0.3,0.5,1.8,2,2.6,2.9         c0.1,0.1,0.1,0.1,0.2,0.2c0.5,0.9,0.3,2.1-0.6,2.7c-0.3,0.2-7.6,6.4-10.6,8c-2.5,1.4-6.2,2.7-10.2,4.2c-4.2,1.5-8.6,3.2-11.4,4.8         c-3.1,1.8-12.7,9.6-12.8,9.7c0,0-0.1,0.1-0.1,0.1C12.7,55.2,12.3,55.3,12,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M46.5,28.1c0.3-0.1,0.7-0.1,1-0.1c0-0.3,0.1-0.7,0.4-0.9c0,0,0,0-0.1,0c-0.6-0.3-1.2-0.6-1.8-1.1 C46.2,26.7,46.4,27.4,46.5,28.1C46.5,28.1,46.5,28.1,46.5,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.4,25.5c-0.5-0.5-1.1-0.9-1.8-1.1l3.1,4.2l0.3-0.2c-0.1-0.4-0.1-0.8,0.1-1.2L42.4,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49.2,24.5l-3.1-4.2c-0.1,0.7,0.1,1.4,0.5,2.1l1.1,2c0.4-0.1,0.8,0.1,1.1,0.3L49.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M45.7,29.2c-0.4,0.2-0.8,0.2-1.2,0c-0.1,0-0.2-0.1-0.2-0.2L44,29.2l1.2,1.7l1.3-0.9 c-0.2-0.3-0.4-0.6-0.5-0.9L45.7,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49,28.1c-0.2-0.2-0.4-0.4-0.6-0.6l0,0.1c-0.3,0.3-0.3,0.8-0.1,1.1L49,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.7,29.2l0.9,1.2c0.1-0.6,0-1.2-0.2-1.7L48.7,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.8,26.1c0,0-2.3-2.3-2.8-3.1c-0.8-1.5-1-4.5-1.5-5.9c-0.4-0.9-3-3.3-3-3.3c-0.3-0.4-0.9-0.6-1.4-0.3 c0,0-7.1,6.1-9.9,7.6c-5.3,2.8-16,5.6-21.3,8.8C14.5,32,4.2,40.2,4.2,40.2c-0.4,0.3-0.6,0.9-0.3,1.4l7.2,12.3 c0.3,0.4,0.9,0.6,1.4,0.3c0,0,9.7-7.9,12.9-9.8c5.4-3.2,16.3-6.1,21.6-9c3-1.6,10.5-7.9,10.5-7.9C57.9,27.2,58.1,26.6,57.8,26.1z  M11.8,51.9L6,41.4l0.9-0.6l6,10.1L11.8,51.9z M14.7,50.1L8.1,40l0.3-0.8l6.9,10.5L14.7,50.1z M17,48.2l-6.8-10.5l0.9-0.6L18,47.6 L17,48.2z M19.1,46.8l-6.8-10.5l0.6-0.4l6.8,10.5L19.1,46.8z M21.5,45.2l-6.8-10.5l0.6-0.4l6.8,10.5L21.5,45.2z M23,44.3l-6.8-10.5 l0.9-0.6l6.8,10.5L23,44.3z M25.8,42.5L18.9,32l1.6-1l6.8,10.5L25.8,42.5z M29.1,40.3l-6.8-10.5l0.6-0.4l6.8,10.5L29.1,40.3z  M31.8,39.2l-6.8-10.5l0.6-0.4l6.8,10.5L31.8,39.2z M33.5,39.1l-6.8-10.5l1.6-1L35.1,38L33.5,39.1z M50.2,31 c-0.1,0.2-0.1,0.4-0.1,0.7c-0.2-0.1-0.4-0.1-0.7-0.1c-1,0-1.8-0.4-2.5-1.1l-1.9,1.4l-6-8.2c1.4-0.2,2.8,0.3,3.8,1.4l2,2.2 c-0.4,0.2-0.5,0.6-0.4,0.9c0.2,0.4,0.6,0.5,0.9,0.4l0.3-0.2c0-0.1,0-0.2,0-0.3c-0.1-1.4-0.7-2.7-1.5-3.8l-2-2.5 c-0.3-0.4-0.5-1-0.4-1.5c0.5,0.1,1,0.4,1.3,0.9l1.8,2.6c0.8,1.1,1.8,2,3.1,2.6c0.1,0,0.2,0.1,0.3,0.1l0.3-0.3 c0.3-0.3,0.2-0.7-0.1-1c-0.3-0.3-0.7-0.2-1,0.1L46,22.8c-0.7-1.2-0.8-2.7-0.1-4l6,8.2L50,28.3C50.4,29.1,50.5,30.1,50.2,31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M49.6,25.1l-0.3,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0,0.8-0.3,1.2L48.9,27c0.3,0.2,0.5,0.5,0.7,0.7l1.3-0.9 L49.6,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.5,30.1c0.4,0.4,0.9,0.6,1.5,0.7l-0.9-1.2L47.5,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.7,28.8L46.7,28.8c0,0.3,0.2,0.6,0.3,0.8l0.7-0.5C47.5,28.7,47.1,28.6,46.7,28.8z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "catal",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6,23c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6c0-0.3,0.3-0.7,0.6-0.7h8.8c0.3,0,0.6,0.3,0.6,0.7v8.6             c0,0.3-0.3,0.7-0.6,0.7H16.6z M30.6,23c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6c0-0.3,0.3-0.7,0.6-0.7h8.8c0.3,0,0.6,0.3,0.6,0.7v8.6             c0,0.3-0.3,0.7-0.6,0.7H30.6z M44.6,23c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6c0-0.3,0.3-0.7,0.6-0.7h8.8c0.3,0,0.6,0.3,0.6,0.7v8.6             c0,0.3-0.3,0.7-0.6,0.7H44.6z M16.6,37c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6c0-0.3,0.3-0.7,0.6-0.7h8.8c0.3,0,0.6,0.3,0.6,0.7v8.6             c0,0.3-0.3,0.7-0.6,0.7H16.6z M44.6,37c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6c0-0.3,0.3-0.7,0.6-0.7h8.8c0.3,0,0.6,0.3,0.6,0.7v8.6             c0,0.3-0.3,0.7-0.6,0.7H44.6z M39.4,27c0.3,0,0.6,0.3,0.6,0.7v8.6c0,0.3-0.3,0.7-0.6,0.7h-8.8c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6             c0-0.3,0.3-0.7,0.6-0.7H39.4z M25.4,41c0.3,0,0.6,0.3,0.6,0.7v8.6c0,0.3-0.3,0.7-0.6,0.7h-8.8c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6             c0-0.3,0.3-0.7,0.6-0.7H25.4z M39.4,41c0.3,0,0.6,0.3,0.6,0.7v8.6c0,0.3-0.3,0.7-0.6,0.7h-8.8c-0.3,0-0.6-0.3-0.6-0.7l0,0v-8.6             c0-0.3,0.3-0.7,0.6-0.7H39.4z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "fldr",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,30.6h-5.9v-9.7c0-1.4-1.4-2.2-2.2-2.2H34.7L31,13.6c-0.3-0.3-1.1-0.7-2.4-0.7H16.2             c-1.3,0-2.2,0.9-2.2,2.2v34.3c-0.2,0.8,1.2,1.7,2,1.7h32.5c0.6,0,1.1-0.3,2-1L62,32.3C62,31.4,61.4,30.6,60,30.6z M19.3,41V18.2h8.6             l4.1,5.8h16.7v6.7H27.4c-0.6,0-1.9,0.4-2,1l-5.9,9.3L19.3,41z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_op",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBBA16",
    d: "M50.5,12.7H27.6l-4.9-6.8C22.3,5.5,21.167,5,19.5,5H2.9C1.167,5,0,6.167,0,7.9V54c0.1,0,53.4-21.4,53.4-21.4             v-17C53.4,13.667,51.5,12.7,50.5,12.7z M7,42.4V12h11.5l5.5,7.7h22.2v9.7L7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCE4A",
    d: "M46.1,55.9H2.7c-1.1,0-3-1.101-2.7-2.2l15.2-23.8c0.2-0.8,1.9-1.3,2.7-1.3h43.4c1.867,0,2.7,1.1,2.7,2.2             L48.8,54.6C47.614,55.537,46.9,55.9,46.1,55.9z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder_opd",
    viewBox: "0 0 64 64"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_op",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_a_op",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M50.5,12.7H27.6l-4.9-6.8C22.3,5.5,21.167,5,19.5,5H2.9C1.167,5,0,6.167,0,7.9V54c0.1,0,53.4-21.4,53.4-21.4             v-17C53.4,13.667,51.5,12.7,50.5,12.7z M7,42.4V12h11.5l5.5,7.7h22.2v9.7L7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f77ce",
    d: "M46.1,55.9H2.7c-1.1,0-3-1.101-2.7-2.2l15.2-23.8c0.2-0.8,1.9-1.3,2.7-1.3h43.4c1.867,0,2.7,1.1,2.7,2.2             L48.8,54.6C47.614,55.537,46.9,55.9,46.1,55.9z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder_a_opd",
    viewBox: "0 0 64 64"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_a_op",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_cl",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBBA16",
    d: "M55.5,12.7H27.6l-4.9-6.8C22.3,5.5,21.4,5,20.5,5H1.9C0.9,5,0,5.9,0,6.9v47.1c0.1,0,0.2,0,0.2,0l57.2-31.4             v-8C57.4,13.6,56.5,12.7,55.5,12.7z M7,42.4V12h11.5l5.5,7.7h26.2l0,6.7L7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCE4A",
    d: "M56.1,56.9H1.7c-1.1,0-2-1.1-1.7-2.2L0,20.9c0.2-0.8,0.9-1.3,1.7-1.3h54.4c1.1,0,1.7,1.1,1.7,2.2l0.1,33.8             C57.6,56.3,56.9,56.9,56.1,56.9z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder_cld",
    viewBox: "0 0 64 64"
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cl",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_cf",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBBA16",
    d: "M55.5,12.7H27.6l-4.9-6.8C22.3,5.5,21.4,5,20.5,5H1.9C0.9,5,0,5.9,0,6.9v47.1c0.1,0,0.2,0,0.2,0l57.2-31.4             v-8C57.4,13.6,56.5,12.7,55.5,12.7z M7,42.4V12h11.5l5.5,7.7h26.2l0,6.7L7,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCE4A",
    d: "M56.1,56.9H1.7c-1.1,0-2-1.1-1.7-2.2L0,20.9c0.2-0.8,0.9-1.3,1.7-1.3h54.4c1.1,0,1.7,1.1,1.7,2.2l0.1,33.8             C57.6,56.3,56.9,56.9,56.1,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,24.5v11.4H47v4.9H36v11.6h-5.1V40.8H20v-4.9h10.9V24.5H36z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder_cfd",
    viewBox: "0 0 64 64"
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cf",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "goods",
    viewBox: "0 0 64 64"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd974",
    d: "M49.7,21.4H2l9.5-11.6h45.3L49.7,21.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebba16",
    d: "M64,21.4H49.7l7.2-11.6L64,21.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5dfa6",
    d: "M11.5,2h45.3v7.8H11.5V2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5dfa6",
    d: "M2,21.4h47.7V64H2V21.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dd7ff",
    d: "M49.7,48.5c-4,0-4,3.9-8,3.9c-4,0-4-3.9-8-3.9s-4,3.9-7.9,3.9s-4-3.9-8-3.9c-4,0-4,3.9-8,3.9             c-4,0-4-3.9-7.9-3.9V64h47.7V48.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#edc832"
    },
    d: "M49.7,21.4H64V64H49.7V21.4z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F78DF4",
    d: "M40.2,33c0-4.3-6.4-7.8-14.3-7.8S11.5,28.7,11.5,33s6.4,7.8,14.3,7.8S40.2,37.3,40.2,33z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "goods_d",
    viewBox: "0 0 64 64"
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#goods",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6AF78",
    points: "42.58,45.212 42.58,37.485 22.799,37.485 22.799,45.212 32.689,54.088 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E71D7",
    d: "M57.922,48.862l-13.6-3.257c-0.281,0-0.393-0.112-0.617-0.226l-11.016,6.464L22.068,45.1             c-0.232,0.28-0.619,0.506-1.012,0.506L7.456,48.862C5.447,49.37,4.07,51.106,4.07,53.079v8.631c0,1.245,1.012,2.245,2.26,2.245             h52.988c1.246,0,2.258-1,2.258-2.245v-8.631C61.406,51.106,59.939,49.37,57.922,48.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D29B6E",
    d: "M22.799,37.485v8.12c12.531,4.495,19.893-6.744,19.893-6.744v-1.376H22.799L22.799,37.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C087",
    d: "M18.303,12.097l1.012,21.144c0.113,1.987,1.123,3.879,2.641,5.003l4.607,3.372             c1.125,0.844,2.5,1.349,3.99,1.349h4.385c1.516,0,2.865-0.505,3.99-1.349l4.607-3.372c1.631-1.236,2.529-3.016,2.643-5.003             l1.01-21.144C47.076,12.097,18.303,12.097,18.303,12.097L18.303,12.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AF78",
    d: "M29.373,16.483c4.385,0,11.016-1.099,12.645-4.386H18.303l0.955,21.144c0.17,1.969,1.068,3.879,2.641,5.003             l4.553,3.372c1.125,0.844,2.529,1.349,3.99,1.349h2.248c-2.191,0-6.633-4.35-6.633-9.836c0-2.754,0-9.896,0-13.271             C26.057,18.733,27.182,16.483,29.373,16.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M12.064,56.792l-7.124-6.354C4.351,51.169,4,52.16,4,53.187v8.602C4,63.015,4.98,64,6.218,64h7.757v-3.059             C13.918,59.347,13.301,57.838,12.064,56.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M53.314,56.792l7.133-6.354c0.566,0.731,0.906,1.723,0.906,2.749v8.602c0,1.227-0.963,2.212-2.195,2.212             h-7.756v-3.059C51.418,59.347,52.078,57.838,53.314,56.792z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#111111",
    points: "35.443,63.955 29.936,63.955 30.609,54.088 34.824,54.088 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M35.443,51.841h-5.508v2.067c0,0.682,0.506,1.234,1.236,1.234h2.979c0.73,0,1.238-0.496,1.238-1.234             L35.443,51.841L35.443,51.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M22.574,42.739l10.115,9.104c0,0-2.865,1.388-6.352,4.256c-0.729,0.573-1.854,0.354-2.191-0.509             l-4.775-10.379l1.516-2.248C21.338,42.401,22.068,42.338,22.574,42.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M42.748,42.739l-10.059,9.102c0,0,2.865,1.351,6.35,4.257c0.73,0.568,1.855,0.35,2.191-0.511l4.768-10.375             l-1.506-2.248C44.041,42.401,43.311,42.338,42.748,42.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785550",
    d: "M39.377,4.819l1.012,7.307c4.721,0.927,5.338,8.351,5.494,10.487c0,0.338,0.125,0.731,0.35,1.069             l1.742,2.756c0,0-0.617-4.645,2.248-7.761C50.279,18.733,51.178,0.38,39.377,4.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C087",
    d: "M49.154,25.986l-1.234,5.005c-0.113,0.562-0.619,0.966-1.236,0.966l0,0c-0.619,0-1.238-0.46-1.406-1.127             l-0.619-5.124c-0.111-1.351,0.9-2.587,2.248-2.587l0,0C48.426,23.119,49.549,24.581,49.154,25.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#694B4B",
    d: "M19.428,2.88l1.619,1.096c-7.41,5.452-6.004,14.757-6.004,14.757c2.191,2.193,2.191,7.761,2.191,7.761             l2.23-2.25c0,0-0.881-6.354,3.277-8.859c3.877-2.248,7.248-1.096,10.723-1.096c9.227,0,11.813-3.484,11.363-7.755             c-0.281-2.164-3.652-6.66-12.139-6.53C29.205,0.127,22.742,1.11,19.428,2.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A4146",
    d: "M18.752,13.361c0,0-1.125-4.636,2.248-9.357c-7.363,5.451-5.957,14.729-5.957,14.729             c2.191,2.193,2.191,7.761,2.191,7.761l2.193-2.217c0,0-0.844-6.387,3.314-8.862c3.877-2.25,7.248-1.126,10.678-1.126             c1.518,0,2.871-0.112,4-0.224C30.328,14.289,26.057,8.866,18.752,13.361z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AF78",
    d: "M16.193,25.986l1.266,5.005c0.113,0.562,0.619,0.966,1.236,0.966l0,0c0.619,0,1.236-0.46,1.35-1.127             l0.662-5.124c0.125-1.351-0.887-2.587-2.256-2.587l0,0C16.953,23.119,15.83,24.581,16.193,25.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A64D3",
    d: "M47.076,61.71H39.32c-0.617,0-1.123,0.495-1.123,1.089v1.099h9.891v-1.099             C48.145,62.205,47.639,61.71,47.076,61.71z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "user_d",
    viewBox: "0 0 64 64"
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#user",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "deps",
    viewBox: "0 0 64 64"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3535",
    d: "M0.5,26c0,0,0,11.251,31.5,11.251S63.5,26,63.5,26s0-11.251-31.5-11.251S0.5,26,0.5,26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.5522,
    y1: 42.79,
    x2: 31.5522,
    y2: 20.2109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8C00"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M5.153,32.035c0,0-3.227,10.755,26.881,10.755c30.106,0,25.806-10.755,25.806-10.755             S62.141,20.21,32.034,20.21C1.926,20.21,5.153,32.035,5.153,32.035z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0005,
    y1: 63.0645,
    x2: 32.0005,
    y2: 25.9395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M0.5,25.939c0,0,0,37.125,31.5,37.125c31.874,0,31.5-37.125,31.5-37.125S62.054,37.187,32,37.187             C2.039,37.187,0.5,25.939,0.5,25.939z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.1113,
    y1: 64.0049,
    x2: 31.1113,
    y2: 49.9951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFBE00"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M55.802,59.483c0,0-5.551,4.521-24.435,4.521c-19.957,0-25.231-3.277-25.231-3.277             s-1.717-1.788-1.814-2.404c-0.968-6.138,1.714-7.927,1.714-7.927s1.372,3.915,3.29,4.446c1.788,0.501,2.472,3.996,2.472,3.996             s0.162-3.333,0.894-4.271c1.098-1.406,5.465-4.573,5.465-4.573s-1.287,4.298-1.194,5.761c0.054,0.839,1.093,3.184,1.093,3.184             s1.086-1.117,3.055-3.383c2.328-2.684,4.792-2.979,4.792-2.979s0.468,2.778,3.178,4.422c2.118,1.283,2.286,3.829,2.286,3.829             s1.428-3.216,2.06-3.829c0.936-0.903,4.202-2.232,4.202-2.232s0.815,1.928,1.758,2.232c1.988,0.638,3.601,2.634,3.601,2.634             s0.684-3.267,1.103-4.29c0.429-1.057,2.273-3.952,2.273-3.952s0.524,2.433,1.204,2.757c2.482,1.195,3.47,4.097,3.47,4.097             s1.813-3.896,3.062-4.39c2.312-0.902,3.99-2.966,3.99-2.966s0.127,3.999-0.229,5.33C57.645,57.039,55.802,59.483,55.802,59.483z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.5342,
    y1: 29.876,
    x2: 45.5342,
    y2: 24.8218,
    gradientTransform: "matrix(0.6529 -0.7574 0.7574 0.6529 -0.5643 32.5145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#787878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M35.41,28.798L59.995,0.276c0,0,0.824-0.957,2.739,0.691c1.913,1.652,1.089,2.607,1.089,2.607             L41.646,29.303c0,0-1.676,1.023-3.818,1.023C35.234,30.326,35.41,28.798,35.41,28.798z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "deps_d",
    viewBox: "0 0 64 64"
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deps",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "menu_",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_m1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4727,
    y1: 55.9678,
    x2: 33.4727,
    y2: 35.6211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA7100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBF3F"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_m1_)",
    d: "M7.68,45.232c0-4.806,14.019-9.611,26.435-9.611c11.295,0,25.153,5.769,25.152,9.611             c-0.001,7.113-13.377,10.735-25.152,10.735C20.576,55.968,7.68,53.965,7.68,45.232z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3119",
    d: "M7.796,37.49c0.288-7.52,14.019-9.612,26.436-9.613c11.294,0,25.035,1.601,25.152,9.613             c0.105,7.109-13.377,10.733-25.152,10.733C20.694,48.224,7.463,46.214,7.796,37.49z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#E43100",
    d: "M15.288,39.334c0,0,3.577,3.044,6.607,3.603c5.771,1.063,8.851-2.243,8.851-2.243l7.48-3.442l3.99,2.923             c0,0,3.617,2.067,6.934,0.864c2.542-0.922,4.455-3.767,4.455-3.767l-4.938-2.479L21.254,35.49L15.288,39.334z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#41BE49",
    d: "M59.348,22.213c0,0-1.604,6.408-8.012,10.094c-7.221,4.152-26.19,4.674-33.323,1.283             C8.239,28.942,7.597,23.175,7.597,23.175s-0.722,0.93-3.842,1.123C0.16,24.52,0.2,22.321,0.122,23.496             C0,25.333,0.869,25.846,1.67,26.38c0.796,0.528,3.204,2.083,3.204,2.083s-2.346,1.846-1.279,3.044             c2.563,2.884,6.78,0.962,8.651,2.084c1.906,1.142,1.456,6.088,4.165,6.407c2.724,0.32,5.288-3.685,5.288-3.685             s-1.114,3.813-0.16,4.326c2.082,1.12,4.325-3.365,4.325-3.365s2.169,1.684,2.723,2.404c0.438,0.567,1.603,2.563,1.603,2.563             s0.979,0,4.005-1.441c1.166-0.557,4.485-2.564,4.485-2.564S39.48,40.8,41.884,40.8c2.178,0,7.05-5.127,7.05-5.127             s0.321,1.762,2.082,1.762c3.049,0,5.65-1.059,6.569-2.564c0.881-1.439-0.642-4.644-0.642-4.644s2.864-0.194,3.686-0.642             c1.764-0.962,3.792-2.739,3.205-3.846c-0.283-0.535-2.403-0.321-2.403-0.321s2.515-2.829,1.922-3.684             C62.779,20.905,59.348,22.213,59.348,22.213z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_m2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.4727,
    y1: 36.3145,
    x2: 33.4727,
    y2: 11.0005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA7100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBF3F"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_m2_)",
    d: "M7.68,23.336C7.68,15.805,21.698,11,34.114,11c11.295,0,25.063,5.297,25.152,12.336             c0.092,7.112-13.377,12.978-25.152,12.978C20.576,36.314,7.68,32.069,7.68,23.336z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "menu_d",
    viewBox: "0 0 64 64"
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menu_",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "print1",
    viewBox: "0 0 64 64"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.854,63.859c-4.571,0-7.711-3.148-7.711-7.719c0-1.711,0-3.285-0.144-4.859L9.002,22v-0.144c0-0.855,0-1.709,0-2.429             v-0.855c0-2.142,1.287-3.428,3.428-3.428c1.143,0,2.142,0,3.285,0h34.706h2.15h0.711c2.285,0,3.572,1.431,3.572,3.572             c0,0.567,0,3.14,0,3.716l-1.71,28.714v5.146c0,4.57-3.149,7.703-7.72,7.703H19.854V63.859z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5327,
    y1: -22.2598,
    x2: 24.5327,
    y2: 23.7295,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p1_)",
    d: "M53.723,50.857c0,1.711,0,3.572,0,5.283c0,3.859-2.438,6.279-6.298,6.279             c-10.142,0-17.421,0-27.571,0c-3.708,0-6.281-2.42-6.281-6.279c0-1.711,0-3.285-0.144-4.994l-2.997-29.29c0-1.143,0-2.286,0-3.428             c0-1.287,0.711-1.998,1.998-1.998c1.143,0,2.142,0,3.285,0h34.706c1.017,0,2.016,0,2.861,0c1.439,0,2.15,0.711,2.15,2.142             c0,1.287,0,2.429,0,3.716L53.723,50.857z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#146CC6",
    d: "M50.421,14.424l2.285,37.144c0.153,0.711,0.153,1.998-0.711,2.861c-0.846,0.863-1.997,1-2.844,1H17.712             c-0.855,0-1.998-0.137-2.708-1c-0.72-0.863-0.864-1.998-0.72-2.861l1.431-46.565c0-2.43,1.431-5.003,5.426-5.003h15.007             L50.421,14.424z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1753,
    y1: -13.9185,
    x2: 25.1753,
    y2: 38.6494,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEEEEE"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p2_)",
    d: "M41.854,15.711c-3.284,0-7.145-0.855-7.145-5.57V1.575H21.141c-3.141,0-3.995,1.854-3.995,3.707             l-1.431,46.576c-0.144,1.709,0.432,2.285,2.142,2.285c11.428,0,20.003,0,31.431,0c1.71,0,2.285-0.711,2.15-2.422l-2.286-35.866             L41.854,15.711z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.857,52.432C5.997,52.432,3,49.57,3,45.863c0-6.299,0-12.715,0-19.008c0-3.28,2.43-5.998,5.714-6.43             c0.855-0.144,1.719-0.144,2.43-0.144h1.431c0.423,0,0.711,0,1.143,0.144c0.711,0.144,1.287,0.72,1.287,1.431v1.719             c0,1.142,0,2.142,0,3.28c0,1.57,0.567,2.719,1.709,3.432c0.432,0.289,1.287,0.424,1.998,0.424h28.426c2.15,0,3.725-1.57,3.725-3.855             c0-1.285,0-2.713,0-4.288v-0.855c0-0.423,0.136-0.711,0.423-0.999c0.288-0.288,0.576-0.432,0.999-0.432c0,0,0,0,0.153,0             c0.558,0,1.134,0,1.709,0.144c1.287,0,2.709,0.144,3.996,0.432C61.003,21.425,63,23.999,63,27.004c0,6.434,0,12.85,0,19.148             c0,3.555-2.861,6.416-6.568,6.416c-0.153,0-0.423,0-0.576,0c-0.135,0-0.999,0-1.286,0c-0.711,0-1.287-0.424-1.422-1.135             c0-0.287-0.153-0.576-0.153-0.863c0-0.289-0.135-0.576-0.135-0.863c-0.423-1.846-1.862-2.844-3.995-2.844H35.147h-7.294             c-3.429,0-6.857,0-10.42-0.154c-1.431,0-4.715,0.441-4.715,4.283c0,0.729-0.432,1.287-1.143,1.439             C11.144,52.279,10.568,52.432,9.857,52.432z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7446,
    y1: -10.7856,
    x2: 24.7446,
    y2: 18.6619,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEEEEE"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p3_)",
    d: "M61.578,26.715c0-2.285-1.574-4.283-3.725-4.714c-1.71-0.288-3.572-0.288-5.417-0.432             c0,1.862,0,3.572,0,5.146c0,2.998-2.286,5.283-5.147,5.283c-10.429,0-18.005,0-28.578,0c-0.854,0-1.854-0.289-2.564-0.711             c-1.719-1-2.43-2.713-2.43-4.572c0-1.574,0-3.284,0-4.858c-0.432,0-0.72,0-0.999,0c-1.287,0-2.574,0-3.716,0.144             c-2.573,0.288-4.427,2.43-4.427,5.003c0,6.434,0,12.715,0,18.994c0,3.15,2.853,5.859,7,4.994c0.135-3.842,2.853-5.705,6.137-5.705             c6.856,0.137,10.717,0,17.574,0c4.57,0,9.142,0,13.713,0c2.709,0,4.724,1.576,5.435,3.996c0.136,0.576,0.136,1.152,0.288,1.863             c0.559,0,1.287,0,1.845,0c2.861,0,5.147-2.15,5.147-4.994C61.714,39.43,61.714,33.148,61.578,26.715z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1D7F1",
    d: "M54.281,23.287c0-0.576-0.136-1.143-0.136-1.718C54.146,22.145,54.146,22.711,54.281,23.287z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1D7F1",
    d: "M54.434,24.43c0-0.432-0.152-0.855-0.152-1.287C54.281,23.71,54.281,24.142,54.434,24.43z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M56.854,41.293l-0.135,0.135C56.72,41.428,56.854,41.428,56.854,41.293z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.722,44.424c-1.151,0-2.016-0.846-2.016-1.998v-2.861c0-0.998,0.864-1.996,2.016-1.996h3.132             c1.151,0,1.997,0.863,1.997,1.996v2.861c0,1.152-0.846,1.998-1.997,1.998H54.722z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DB053",
    d: "M58.429,42.58c0,0.27-0.287,0.557-0.575,0.557h-3.132c-0.288,0-0.576-0.287-0.576-0.557v-2.861             c0-0.289,0.288-0.576,0.576-0.576h3.132c0.288,0,0.575,0.287,0.575,0.576V42.58z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "print1_d",
    viewBox: "0 0 64 64"
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print1",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "print2",
    viewBox: "0 0 64 64"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.854,63.859c-4.571,0-7.711-3.148-7.711-7.719c0-1.711,0-3.285-0.144-4.859L9.002,22v-0.144c0-0.855,0-1.709,0-2.429             v-0.855c0-2.142,1.287-3.428,3.428-3.428c1.143,0,2.142,0,3.285,0h34.706h2.15h0.711c2.285,0,3.572,1.431,3.572,3.572             c0,0.567,0,3.14,0,3.716l-1.71,28.714v5.146c0,4.57-3.149,7.703-7.72,7.703H19.854V63.859z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p12_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.5327,
    y1: -22.2598,
    x2: 24.5327,
    y2: 23.7295,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#555555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#888888"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p12_)",
    d: "M53.723,50.857c0,1.711,0,3.572,0,5.283c0,3.859-2.438,6.279-6.298,6.279             c-10.142,0-17.421,0-27.571,0c-3.708,0-6.281-2.42-6.281-6.279c0-1.711,0-3.285-0.144-4.994l-2.997-29.29c0-1.143,0-2.286,0-3.428             c0-1.287,0.711-1.998,1.998-1.998c1.143,0,2.142,0,3.285,0h34.706c1.017,0,2.016,0,2.861,0c1.439,0,2.15,0.711,2.15,2.142             c0,1.287,0,2.429,0,3.716L53.723,50.857z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#146CC6",
    d: "M50.421,14.424l2.285,37.144c0.153,0.711,0.153,1.998-0.711,2.861c-0.846,0.863-1.997,1-2.844,1H17.712             c-0.855,0-1.998-0.137-2.708-1c-0.72-0.863-0.864-1.998-0.72-2.861l1.431-46.565c0-2.43,1.431-5.003,5.426-5.003h15.007             L50.421,14.424z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1753,
    y1: -13.9185,
    x2: 25.1753,
    y2: 38.6494,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEEEEE"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p2_)",
    d: "M41.854,15.711c-3.284,0-7.145-0.855-7.145-5.57V1.575H21.141c-3.141,0-3.995,1.854-3.995,3.707             l-1.431,46.576c-0.144,1.709,0.432,2.285,2.142,2.285c11.428,0,20.003,0,31.431,0c1.71,0,2.285-0.711,2.15-2.422l-2.286-35.866             L41.854,15.711z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.857,52.432C5.997,52.432,3,49.57,3,45.863c0-6.299,0-12.715,0-19.008c0-3.28,2.43-5.998,5.714-6.43             c0.855-0.144,1.719-0.144,2.43-0.144h1.431c0.423,0,0.711,0,1.143,0.144c0.711,0.144,1.287,0.72,1.287,1.431v1.719             c0,1.142,0,2.142,0,3.28c0,1.57,0.567,2.719,1.709,3.432c0.432,0.289,1.287,0.424,1.998,0.424h28.426c2.15,0,3.725-1.57,3.725-3.855             c0-1.285,0-2.713,0-4.288v-0.855c0-0.423,0.136-0.711,0.423-0.999c0.288-0.288,0.576-0.432,0.999-0.432c0,0,0,0,0.153,0             c0.558,0,1.134,0,1.709,0.144c1.287,0,2.709,0.144,3.996,0.432C61.003,21.425,63,23.999,63,27.004c0,6.434,0,12.85,0,19.148             c0,3.555-2.861,6.416-6.568,6.416c-0.153,0-0.423,0-0.576,0c-0.135,0-0.999,0-1.286,0c-0.711,0-1.287-0.424-1.422-1.135             c0-0.287-0.153-0.576-0.153-0.863c0-0.289-0.135-0.576-0.135-0.863c-0.423-1.846-1.862-2.844-3.995-2.844H35.147h-7.294             c-3.429,0-6.857,0-10.42-0.154c-1.431,0-4.715,0.441-4.715,4.283c0,0.729-0.432,1.287-1.143,1.439             C11.144,52.279,10.568,52.432,9.857,52.432z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_p32_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7446,
    y1: -10.7856,
    x2: 24.7446,
    y2: 18.6619,
    gradientTransform: "matrix(1 0 0 -1 8.3999 40.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_p32_)",
    d: "M61.578,26.715c0-2.285-1.574-4.283-3.725-4.714c-1.71-0.288-3.572-0.288-5.417-0.432             c0,1.862,0,3.572,0,5.146c0,2.998-2.286,5.283-5.147,5.283c-10.429,0-18.005,0-28.578,0c-0.854,0-1.854-0.289-2.564-0.711             c-1.719-1-2.43-2.713-2.43-4.572c0-1.574,0-3.284,0-4.858c-0.432,0-0.72,0-0.999,0c-1.287,0-2.574,0-3.716,0.144             c-2.573,0.288-4.427,2.43-4.427,5.003c0,6.434,0,12.715,0,18.994c0,3.15,2.853,5.859,7,4.994c0.135-3.842,2.853-5.705,6.137-5.705             c6.856,0.137,10.717,0,17.574,0c4.57,0,9.142,0,13.713,0c2.709,0,4.724,1.576,5.435,3.996c0.136,0.576,0.136,1.152,0.288,1.863             c0.559,0,1.287,0,1.845,0c2.861,0,5.147-2.15,5.147-4.994C61.714,39.43,61.714,33.148,61.578,26.715z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1D7F1",
    d: "M54.281,23.287c0-0.576-0.136-1.143-0.136-1.718C54.146,22.145,54.146,22.711,54.281,23.287z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1D7F1",
    d: "M54.434,24.43c0-0.432-0.152-0.855-0.152-1.287C54.281,23.71,54.281,24.142,54.434,24.43z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M56.854,41.293l-0.135,0.135C56.72,41.428,56.854,41.428,56.854,41.293z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.722,44.424c-1.151,0-2.016-0.846-2.016-1.998v-2.861c0-0.998,0.864-1.996,2.016-1.996h3.132             c1.151,0,1.997,0.863,1.997,1.996v2.861c0,1.152-0.846,1.998-1.997,1.998H54.722z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#D05300",
    d: "M58.429,42.58c0,0.27-0.287,0.557-0.575,0.557h-3.132c-0.288,0-0.576-0.287-0.576-0.557v-2.861             c0-0.289,0.288-0.576,0.576-0.576h3.132c0.288,0,0.575,0.287,0.575,0.576V42.58z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "print2_d",
    viewBox: "0 0 64 64"
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print2",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "discon",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M58.7,39.3l-0.2,0.2C58.5,39.4,58.7,39.4,58.7,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,64.9c-0.9,0-1.6-0.6-1.7-0.9C15.3,57.9,8,50.8,0.9,43.5C0.4,43.1,0,42.6,0,41.8s0.6-1.5,0.9-1.7c2.8-2.8,5.5-5.4,8-8             c6.8-6.8,13.7-13.7,20.4-20.5c0.7-0.7,1.5-1,2.3-1h0.1c3.3,0.1,6.7,0.3,10.1,0.4c0,0,5.5,0.1,5.7,0.1c0.4,0,0.7,0,1.2,0s0.7,0,1.2,0             h0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.4,0,0.6,0c0.4,0,1.2,0,1.7,0.6c1,0.7,0.9,1.9,0.7,2.6c0,0.1,0,0.3,0,0.6c0,0.3,0,0.4-0.1,0.7             c0.1,0.1,0.1,0.4,0.1,0.6c0.1,4.5,0.3,9,0.4,13.5v0.9c0,0.7,0,1.5,0.1,2.2c0.2,1.3-0.6,2.2-1,2.8c-2,1.9-4.2,4.1-6.4,6.3             c-4.1,4.2-8.1,8.3-12.2,12.4c-3.4,3.2-6.6,6.6-9.8,9.9C24.5,64.3,23.9,64.9,23,64.9z M41.6,20.5c-1.2,0-2.2,0.9-2.2,2             c0,0.9,0.4,1.7,1.3,2.2c0.3,0.1,0.6,0.1,1,0.1c0.6,0,1.2-0.1,1.6-0.6c0.7-0.7,0.9-1.6,0.4-2.6c0-0.1,0-0.1-0.1-0.3l0,0             c-0.2-0.1-0.3-0.1-0.4-0.3l-0.2-0.1c-0.1,0-0.1-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.3-0.1h-0.1c-0.1,0-0.1,0-0.3,0             C41.9,20.5,41.8,20.5,41.6,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD974",
    d: "M52.1,16.3c0.1,4.5,0.3,9,0.4,13.5c0,1,0,2.2,0.1,3.2c0,0.6-0.1,1-0.6,1.5c-2.2,2-4.4,4.1-6.4,6.3             C38.6,48.3,31,55.6,23.7,63c-0.6,0.6-0.9,0.6-1.5,0C15.4,56.2,8.6,49.3,1.7,42.5c-0.6-0.6-0.4-0.9,0-1.3c2.8-2.6,5.4-5.2,8-8             c6.8-6.8,13.7-13.7,20.4-20.5c0.4-0.4,0.9-0.6,1.5-0.6c5,0.1,9.8,0.4,14.7,0.6c0.4,0,0.7,0,1.2,0c0.7,0,1.5,0.1,2.3,0.1             c0.7,0,1.6-0.1,2,0.1c0.6,0.4,0.2,1.5,0.2,2.2c-2.8,1.3-5.4,3.1-7.6,5.1c-0.3-0.1-0.6-0.6-0.9-0.6c-0.4-0.3-0.7-0.4-1.2-0.4             c-2.2-0.4-4.2,1.2-4.4,3.3c0,1.5,0.7,2.9,2.2,3.6c1.3,0.6,3.1,0.4,4.1-0.6c1.2-1,1.4-2.6,0.9-4.2C47,19,49.5,17.4,52.1,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,4.2c-0.3-1.5-1.2-2.3-2.8-2.2c-0.9,0-1.6,0.3-2.3,0.6c-3.8,1.7-7.1,4.1-10,7c-0.9,0.9-1.6,1.9-2.3,2.9             c0.4,0,0.7,0,1.2,0c0.7-1.3,1.7-2.5,2.9-3.5c2.5-2,5.1-3.6,7.9-5.1C59.1,3.5,60,3.2,60.9,3c1.3-0.3,2,0.3,2.2,1.6             c0.1,1,0,1.9-0.6,2.8C62,8,61.7,8.6,61.1,9c-2.6,2.5-5.7,4.4-9,6c-2.8,1.3-5.4,3.1-7.6,5.1c-0.6,0.6-1.2,1.2-1.9,1.5             c0.3-0.7,0.7-1.5,1-2.2c-0.4-0.3-0.7-0.4-1.2-0.4c-0.3,0.7-0.7,1.6-0.9,2.5c-0.1,0.6-0.1,1,0.4,1.3c0.4,0.3,1,0.3,1.4-0.1             c0.6-0.4,1.2-1,1.7-1.5c1.9-2.2,4.4-3.6,7-4.8c2-1.2,4.2-2.3,6.3-3.6c1.5-1,3.1-2.2,4.2-3.6C63.8,7.5,64.2,5.9,63.9,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,37.8c1.6,1.6,2.5,3.2,2.5,4.8c0,1.6-0.7,3.1-2.2,4.5c-1.5,1.5-3.1,2.2-4.5,2.2c-1.6,0-3-0.9-4.7-2.5             c-1.6-1.6-2.5-3.2-2.5-4.8c0-1.6,0.7-3.1,2.2-4.5c1.5-1.5,3.1-2.2,4.5-2.2C18.1,35.3,19.5,36.2,21.1,37.8z M18.3,40.7             c-1.2-1-1.9-1.6-2.5-1.7c-0.6-0.2-1.2,0-1.7,0.7c-0.6,0.6-0.7,1.2-0.6,1.7c0.1,0.6,0.7,1.5,1.7,2.5c1,1,1.9,1.7,2.5,1.7             c0.7,0.1,1.3-0.2,1.7-0.6c0.6-0.6,0.7-1.2,0.7-1.7C19.9,42.6,19.4,41.8,18.3,40.7z M24.5,25.7l7,22.4l-2.6,2.6l-7.1-22.4L24.5,25.7z              M40.8,29.7c1.6,1.6,2.5,3.2,2.5,4.8c0,1.6-0.7,3.1-2.2,4.5c-1.5,1.4-3.1,2.2-4.5,2.2c-1.6,0-3.1-0.9-4.7-2.5             c-1.6-1.6-2.5-3.2-2.5-4.8c0-1.6,0.7-3.1,2.2-4.5c1.5-1.5,3.1-2.2,4.5-2.2C37.6,27.2,39.2,28.1,40.8,29.7z M37.9,32.6             c-1.2-1-1.9-1.6-2.5-1.7c-0.6-0.1-1.2,0.1-1.7,0.6c-0.6,0.6-0.7,1.2-0.6,1.7c0.1,0.6,0.7,1.5,1.7,2.5c1,1,1.9,1.6,2.5,1.7             c0.6,0.1,1.2-0.1,1.7-0.6c0.6-0.6,0.9-1.2,0.7-1.7C39.4,34.5,38.9,33.6,37.9,32.6z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "discon_d",
    viewBox: "0 0 64 64"
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#discon",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hall",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hall1_",
    cx: 30,
    cy: 25,
    r: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#7A61FC"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#hall1_)",
    d: "M57,26c0,13.8-25,38-25,38S7,39.8,7,26C7,12.2,18.2,1,32,1             S57,12.2,57,26z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hall2_",
    cx: 28,
    cy: 18,
    r: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#hall2_)",
    d: "M50.5,25c0,10.2-8.3,18.5-18.5,18.5             c-10.2,0-18.5-8.3-18.5-18.5c0-10.2,8.3-18.5,18.5-18.5C42.2,6.5,50.5,14.8,50.5,25z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#444444",
    d: "M21,16.4c-0.1,1.1,0.3,2.3,1,3.3c0.3,0.5,0.7,1,1.2,1.4                 c0.3,0.3,0.5,0.5,0.6,0.9c0.6,2.9,0.9,5.7,0.3,8.6c-0.4,1.9-0.8,3.8-1.2,5.7c-0.1,0.5-0.1,1,0.1,1.5c0.2,0.8,0.8,1.2,1.7,1.3                 c0.4,0,0.8,0,1.3-0.1c0.9-0.1,1.3-0.6,1.5-1.3c0.2-0.8,0-1.7-0.2-2.5c-0.1-0.3-0.1-0.6-0.3-0.8c-0.8-1.8-1-3.7-1.1-5.7                 c-0.1-1.9-0.1-3.8,0.4-5.8c0.2-0.8,0.6-1.5,1.3-2.1c1.1-1,1.5-2.2,1.6-3.5c0.2-1.5-0.1-3-1-4.3c-0.3-0.4-0.6-0.8-1-1.1                 c-1.2-1-2.8-0.9-4,0c-0.9,0.7-1.4,1.5-1.7,2.5C21.3,14.9,21,15.6,21,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#444444",
    d: "M38.8,11c-0.1,0.2-0.2,0.4-0.2,0.5c-0.1,0.9-0.2,1.8-0.3,2.8                 c-0.1,1,0,2-0.1,2.9c0,0.2,0,0.4-0.2,0.5c-0.3,0.2-0.6,0-0.6-0.3c0-1.3,0-2.6-0.1-4c0-0.7-0.2-1.3-0.3-2c0-0.1-0.1-0.3-0.2-0.4                 c0,0-0.1,0-0.2,0c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.9-0.3,1.9-0.3,2.8c0,1,0,1.9,0,2.9c0,0.1,0,0.2,0,0.3c-0.1,0.1-0.3,0.3-0.4,0.3                 c-0.3,0-0.3-0.2-0.3-0.4c0-1.3,0-2.6-0.1-3.9c0-0.7-0.2-1.4-0.3-2.2c0-0.1-0.1-0.3-0.2-0.4c0,0-0.1,0-0.1,0                 c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,1-0.4,2-0.5,3c-0.1,1.3-0.1,2.5-0.1,3.8c0,1.2,0.5,2.3,1.8,3.1c0.7,0.5,1,1.1,1.1,1.8                 c0.2,1.2,0.4,2.4,0.3,3.5c0,2.4-0.3,4.9-1,7.3c-0.2,0.9-0.4,1.7-0.6,2.6c-0.1,0.3,0,0.6,0,0.9c0.2,1,1.1,1.5,2.4,1.5                 c1.5-0.1,2.3-0.7,2.3-1.9c0-0.8-0.2-1.6-0.4-2.3c-0.4-1.6-0.9-3.2-1.2-4.8c-0.4-1.8-0.1-3.7,0.1-5.6c0.1-0.6,0.2-1.2,0.3-1.8                 c0.1-0.5,0.4-0.9,1-1.2c1.2-0.6,1.8-1.5,2-2.6C42,18,42,17.1,42,16.3c-0.1-1.6-0.4-3.1-0.6-4.7c0-0.2-0.2-0.4-0.4-0.5                 c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,1.5-0.3,3-0.4,4.5c0,0.4,0,0.8,0.1,1.1c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.4,0.4                 c-0.3,0-0.4-0.2-0.4-0.4c0-0.8,0-1.7,0-2.5c-0.1-1.1-0.2-2.2-0.3-3.3c0-0.2-0.2-0.4-0.2-0.6C39,11,38.9,11,38.8,11z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "hall_d",
    viewBox: "0 0 64 64"
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hall",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "cotr",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9C295",
    stroke: "#000000",
    d: "M6.4,36l7.3,5.1l0,0l13.1,11.4l1.4,1.3c1.1,1,2.9,0.9,3.9-0.3l1.9-2.3             c0.5,0.4,1,0.6,1.5,0.6c0.9,0.1,1.8-0.3,2.4-1l1.9-2.3c0.5,0.4,1,0.6,1.5,0.6c1.3,0,3.2-1.4,3.1-2.6L44,44.9c1.1,1,3,0.9,4-0.3             l0.4-0.6c0.6-1.3,0.1-2.8-0.8-3.5l-4.2-3.9l-1.8-1.5l-1.3-1.1l-5.5-4.7l0.6-5.4c0.3-1.8-0.9-3.5-2.8-4l-12-3.3             c-1.3-0.4-3.1,0.3-3.7,1.4l-0.6,1l-2.8-0.7L6.4,36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E59F6A",
    d: "M46.3,42.5c-0.9,1.1-2,2.3-3.4,1.1c-1.1,1.9-2.8,5.4-5.6,3.5c-0.5-0.4-0.5,0-0.8,0.4c-0.4,0.5-0.9,1-1.3,1.5             c-1.1,1.3-3,1.8-4.4,0.5c-0.9,1.3-1.7,2.6-2.6,3.9c2,1.8,3.6,0,5-1.5c0.3-0.3,0.5-0.6,0.8-0.9c0.3-0.3,0.8,0.4,1.2,0.5             c1.1,0.4,2.1-0.3,2.9-1.1c0.5-0.6,1.1-1.3,1.6-1.9c0.4-0.4,0.4,0,0.9,0.3c0.6,0.4,1.3,0.4,2.4-0.3c1.9-1.3,1.1-1.2,1.2-3.9             c1.4,1.2,3.7,1,4.4-0.5c0.6-1.5,0.4-2-0.6-3.4L46.3,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29F5C",
    stroke: "#000000",
    d: "M13.6,40.7l-0.8,1c-0.8,1.1-0.6,2.6,0.5,3.5l0,0c1.1,0.8,2.6,0.6,3.4-0.5l0.8-1             c0.8-1.1,0.6-2.6-0.4-3.5l0,0C16,39.4,14.4,39.6,13.6,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29F5C",
    stroke: "#000000",
    d: "M18.2,43l-1.5,1.9c-0.8,1.1-0.6,2.6,0.5,3.5l0,0c1.1,0.8,2.6,0.6,3.5-0.5l1.5-1.9             c0.8-1.1,0.6-2.6-0.5-3.4l0,0C20.6,41.6,19.1,41.9,18.2,43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29F5C",
    stroke: "#000000",
    d: "M22.8,45.3l-2,2.6c-0.8,1.1-0.6,2.6,0.5,3.5l0,0c1.1,0.8,2.6,0.6,3.5-0.5l2-2.6             c0.8-1.1,0.6-2.6-0.5-3.5l0,0C25.1,44,23.6,44.2,22.8,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29F5C",
    stroke: "#000000",
    d: "M26.8,48.1l-2.1,2.8c-0.8,1.1-0.6,2.6,0.5,3.5l0,0c1.1,0.8,2.6,0.6,3.5-0.5l2.1-2.8             c0.8-1.1,0.6-2.6-0.5-3.5l0,0C29.2,46.8,27.6,47,26.8,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C9CEE",
    d: "M60.1,38.5c-0.7,0.3-1.4,0.3-2,0S57,37.7,56.8,37l-3.9-10.1L49,16.7c-0.3-0.7-0.3-1.4,0-2s0.8-1.1,1.5-1.4             l9.3-3.4L64,21.3v15.9L60.1,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3580D3",
    d: "M59.3,35.6c-1.4,0.5-3-0.1-3.6-1.4l1.1,2.8c0.5,1.4,2.1,2,3.4,1.5l3.8-1.3v-3.4L59.3,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED5575",
    d: "M2.8,38.6c0.7,0.3,1.4,0.3,1.8,0c0.5-0.3,0.9-0.6,1.1-1.4l8.7-21.1c0.3-0.7,0-1.4-0.4-2             c-0.4-0.6-0.9-1.1-1.6-1.3L3.9,9.1L0,19.4v17.9L2.8,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC3A60",
    d: "M3.6,35.5L0,33.6v3.6l3.1,1.3c1.4,0.4,2.3,0,2.6-1.5l1-2.6C6.1,35.5,4.8,35.9,3.6,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEF2",
    stroke: "#000000",
    d: "M59.8,31.1c1.1,0,1.9,0.9,1.9,1.9c0,1.1-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9             C57.8,31.9,58.7,31.1,59.8,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEF2",
    stroke: "#000000",
    d: "M2.8,31.7c1.1,0,1.9,0.9,1.9,1.9c0,1.1-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9             C0.8,32.6,1.7,31.7,2.8,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29F5C",
    stroke: "#000000",
    d: "M49.4,18.2l6.8,17.6l-9,2.6c-0.3,0-0.6,0.8-0.8,0.9L33.4,28.1c0,0,2.6,0.3,3.6-0.3             c2.5-1.2,4.4-3.5,4.4-3.5c-2,2.5-4.2,3.9-6.4,3.9c-3.2,0.1-5.6-2.6-5.6-2.6c-0.3-0.3-0.5-0.4-0.8-0.4c-0.4,0-0.6,0.1-0.8,0.4             l-2.7,3.7c-1.4,1.8-3.9,2.5-6,1.7L19,30.8c-0.3-0.1-0.4-0.3-0.4-0.4s-0.1-0.4,0-0.6l7-12.1c0.5-0.8,1.3-1.9,2.1-2l4.1-0.8l3.2-0.5             h2.1c0.6,0,1.4,0.4,1.9,0.6l6.1,3.5L49.4,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D37D42",
    d: "M55.8,35.5l-1.1-3l-8.6,2.3l0,0l-2,2.2l2.3,2l0.6-0.8L55.8,35.5z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "cotr_d",
    viewBox: "0 0 64 64"
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cotr",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "coins",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3C129",
    d: "M34.2,53.2H3.1c-1.7,0-3.1-1.4-3.1-3.1v-4.6c0-1.7,1.4-3.1,3.1-3.1h31.1c1.7,0,3.1,1.4,3.1,3.1v4.6             C37.3,51.8,35.9,53.2,34.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6B41A",
    d: "M34.2,50.1H3.1C1.4,50.1,0,48.7,0,47v3.1c0,1.7,1.4,3.1,3.1,3.1h31.1c1.7,0,3.1-1.4,3.1-3.1V47             C37.3,48.7,35.9,50.1,34.2,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE246",
    d: "M37.7,42.5H6.6c-1.7,0-3.1-1.4-3.1-3.1v-4.6c0-1.7,1.4-3.1,3.1-3.1h31.1c1.7,0,3.1,1.4,3.1,3.1v4.6             C40.8,41.1,39.4,42.5,37.7,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6B41A",
    d: "M37.7,39.4H6.6c-1.7,0-3.1-1.4-3.1-3.1v3.1c0,1.7,1.4,3.1,3.1,3.1h31.1c1.7,0,3.1-1.4,3.1-3.1v-3.1             C40.8,38,39.4,39.4,37.7,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C129",
    d: "M34.2,31.7H3.1c-1.7,0-3.1-1.4-3.1-3.1V24c0-1.7,1.4-3.1,3.1-3.1h31.1c1.7,0,3.1,1.4,3.1,3.1v4.6             C37.3,30.3,35.9,31.7,34.2,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6B41A",
    d: "M34.2,28.6H3.1c-1.7,0-3.1-1.4-3.1-3.1v3.1c0,1.7,1.4,3.1,3.1,3.1h31.1c1.7,0,3.1-1.4,3.1-3.1v-3.1             C37.3,27.2,35.9,28.6,34.2,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE246",
    d: "M37.7,20.9H6.6c-1.7,0-3.1-1.4-3.1-3.1v-4.6c0-1.7,1.4-3.1,3.1-3.1h31.1c1.7,0,3.1,1.4,3.1,3.1v4.6             C40.8,19.5,39.4,20.9,37.7,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6B41A",
    d: "M37.7,17.8H6.6c-1.7,0-3.1-1.4-3.1-3.1v3.1c0,1.7,1.4,3.1,3.1,3.1h31.1c1.7,0,3.1-1.4,3.1-3.1v-3.1             C40.8,16.4,39.4,17.8,37.7,17.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAD52D",
    cx: 45.3,
    cy: 34.9,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAE246",
    cx: 45.3,
    cy: 34.9,
    r: 14.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6B41A",
    d: "M44.6,43c-2.9-0.1-5.3-1.6-5.3-3.1c0-0.8,0.7-2,1.6-2c1,0,1.8,1.4,3.6,1.7v-3.9c-2.2-0.8-4.8-1.9-4.8-5             c0-3.1,2.3-4.5,4.8-4.9v-0.7c0-0.3,0.4-0.7,0.9-0.7c0.5,0,0.9,0.3,0.9,0.7v0.6c1.5,0,4.3,0.4,4.3,2.1c0,0.7-0.4,2-1.5,2             c-0.8,0-1.3-0.8-2.8-0.9v3.5c2.2,0.8,4.8,2,4.8,5.2c0,3-1.9,4.8-4.8,5.3v0.7c0,0.3-0.5,0.7-0.9,0.7c-0.5,0-0.9-0.3-0.9-0.7L44.6,43             L44.6,43z M44.9,31.8V29c-1.1,0.2-1.5,0.8-1.5,1.4C43.3,31,43.9,31.4,44.9,31.8z M46.2,36.3v3.2c0.8-0.2,1.5-0.7,1.5-1.5             C47.7,37.2,47.1,36.7,46.2,36.3z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "coins_d",
    viewBox: "0 0 64 64"
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coins",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "artic",
    viewBox: "0 0 64 64"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3,4.5C52.5-2.2,46.1,2,41.5,6.8l0,0L5.1,43.1l0,0l0,0l0,0l0,0L1,62l0,0l0,0l0,0l0,0l0,0l0,0l1.1,1.1l0,0L21,58.8l0,0             l0,0l0,0l0,0l36.2-36.4l0,0C62.2,17.4,66.2,11.3,59.3,4.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#777777",
    d: "M58.3,5.5c6.8,6.9,0.6,13.1,0.6,13.1L45.3,5.1C45.2,5.1,51.6-1.2,58.3,5.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "40,10.4 53.6,24 50.9,26.7 37.3,13.1 "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1A6",
    d: "M10.9,53.2l8.2-1.7l1.1,6.1L5.3,61l2-2c0,0,0.3-1.2-0.2-1.7c-0.5-0.4-1.7-0.1-1.7-0.1l-2,2l3.2-14.8l5.6,0.3             L10.9,53.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "art_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.5215,
    y1: 10.1382,
    x2: 28.7549,
    y2: -5.0953,
    gradientTransform: "matrix(1 0 0 -1 8.3398 40.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7C00F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98620E"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#art_1_)",
    d: "M20.5,50.8L42,29.1c0,0,0.8-1.2,0.4-1.5c-0.3-0.3-1.5,0.5-1.5,0.5L19.3,50l-6.4,1.2l0.6-6.9L35.7,22             c0,0,0.8-1.4,0.5-1.5c-0.3-0.3-1.5,0.6-1.5,0.6L12.7,43l-5.2-0.2l28.8-28.8l13.5,13.6L21.4,56.1L20.5,50.8z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "44.2,6.1 57.8,19.7 54.7,22.8 41.1,9.3 "
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "artic_d",
    viewBox: "0 0 64 64"
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artic",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "retur",
    viewBox: "4 10 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,36.7c0-10.9-8.2-19.2-19.1-19.2h-5v-5.8l-0.3-0.4L12.9,23.1l13.7,11.1l0.4-0.4v-5.1h4.7             c3.4,0,6.6,1.2,9,3.2c2.5,2.1,3.9,5.2,3.9,8.5c0,5.7-3.8,10.8-8.8,12.6C45.3,51.7,51,45.7,51,36.7z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "retur_d",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#retur",
    fill: "#EC3455",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#D0452D",
    width: 48,
    height: 48,
    x: 1,
    y: 16
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "termi",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3,17.7c-0.2,0.1-0.4,0.2-0.6,0.4c-8.6,8.6-17.2,17.2-25.8,25.8 c-1.5,1.5-2.6,3.1-3,5.1c-0.4,2.1,0,3.9,1.4,5.6c0.7,0.8,1.2,1.8,1.8,2.7c0,0.1-0.1,0.1-0.2,0.2c-0.5-0.1-1.1-0.2-1.6-0.3 c-4.9-1.3-9.7-2.8-14.3-4.8c-1.7-0.8-3.2-2.1-4.7-3.3c-1.3-1.1-2.5-2.4-3.7-3.6c-2.5-2.7-2.3-7.3,0.5-9.8 c8.6-7.9,17.3-15.8,25.9-23.7c0.5-0.5,0.9-0.6,1.7-0.4c7.3,2,14.6,3.9,21.9,5.9c0.2,0,0.3,0.1,0.5,0.2 C53.2,17.5,53.3,17.6,53.3,17.7z M49,19.3c-0.2-0.1-0.2-0.1-0.3-0.1C42.5,17.5,36.2,15.8,30,14c-0.2-0.1-0.6,0.1-0.8,0.3 c-1.3,1.1-2.7,2.3-4,3.5c-1.3,1.2-2.6,2.3-4,3.5c0.2,0.1,0.3,0.1,0.4,0.2c6.3,1.9,12.6,3.8,18.9,5.7c0.4,0.1,0.6,0,0.9-0.2 c2-2,4-4,6.1-6C47.9,20.4,48.4,19.9,49,19.3z M3.5,40.5c-0.2,0.5-0.4,0.9-0.5,1.4c-0.6,1.8-0.4,2.1,1.1,3.1 c4.5,2.9,9.4,4.7,14.5,5.9c0.6,0.1,1.2,0.2,1.7,0.3c0.3-1.1,0.6-2.1,0.8-3.1c0.2-0.9,0-1.2-0.9-1.5c-1.6-0.5-3.2-0.9-4.7-1.4 c-2-0.6-4-1.1-6-1.9C7.4,42.6,5.5,41.5,3.5,40.5z M31.8,27.4c-1.9-0.5-3.7-1-5.4-1.5c-0.1,0-0.3,0-0.4,0c-0.8,0.7-1.6,1.3-2.4,2.1 c2,0.6,3.8,1.2,5.7,1.7c0.1,0,0.3,0,0.4-0.1C30.3,28.9,31,28.1,31.8,27.4z M13.1,29.5c2,0.6,3.8,1.2,5.7,1.7c0.1,0,0.3,0,0.4-0.1 c0.7-0.7,1.5-1.5,2.2-2.2c-1.9-0.5-3.7-1-5.5-1.5c-0.1,0-0.3,0-0.4,0.1C14.7,28.1,13.9,28.8,13.1,29.5z M30.6,30 c1.9,0.6,3.8,1.2,5.6,1.7c0.1,0,0.4,0,0.5,0c0.7-0.7,1.5-1.5,2.2-2.2c-1.9-0.5-3.7-1-5.6-1.5c-0.1,0-0.3,0-0.4,0.1 C32.2,28.6,31.5,29.2,30.6,30z M18.2,32.2c-1.9-0.5-3.8-1-5.6-1.5c-0.1,0-0.3,0-0.4,0.1c-0.8,0.6-1.5,1.3-2.4,2.1 c2,0.6,3.8,1.2,5.7,1.7c0.1,0,0.3,0,0.4-0.1C16.8,33.7,17.5,33,18.2,32.2z M21.8,37.7c-1.9-0.5-3.6-1-5.4-1.5 c-0.2-0.1-0.4-0.1-0.5,0c-0.8,0.7-1.5,1.3-2.4,2.1c2,0.6,3.8,1.2,5.7,1.7c0.1,0.1,0.3,0,0.4-0.1C20.3,39.2,21,38.4,21.8,37.7z  M14.7,35.7c-1.8-0.5-3.7-1-5.5-1.5c-0.1,0-0.3,0-0.4,0.1c-0.8,0.6-1.5,1.3-2.3,2c0.1,0.1,0.1,0.1,0.1,0.1c1.8,0.6,3.6,1.1,5.4,1.6 c0.1,0,0.4,0,0.5-0.1C13.3,37.1,14,36.4,14.7,35.7z M28.3,30.9c-0.1,0-0.1-0.1-0.1-0.1c-1.8-0.5-3.5-1-5.3-1.5c-0.1,0-0.3,0-0.3,0 c-0.8,0.7-1.6,1.3-2.5,2.1c1.9,0.6,3.8,1.2,5.6,1.7c0.2,0,0.4,0,0.5-0.1C26.9,32.4,27.6,31.7,28.3,30.9z M27.2,33.5 c2,0.6,3.8,1.1,5.6,1.7c0.1,0.1,0.4,0,0.5-0.1c0.7-0.7,1.4-1.4,2.2-2.2c-1.9-0.5-3.7-1-5.6-1.5c-0.1,0-0.3,0-0.4,0.1 C28.7,32.1,28,32.7,27.2,33.5z M16.9,34.8c2,0.6,3.8,1.1,5.6,1.7c0.1,0,0.3,0,0.4,0c0.8-0.7,1.5-1.5,2.2-2.3 c-1.8-0.5-3.6-1-5.4-1.5c-0.2,0-0.5,0-0.6,0.1C18.4,33.5,17.7,34.1,16.9,34.8z M20.5,40.2c2,0.6,3.8,1.2,5.7,1.8 c0.1,0,0.2,0,0.3-0.1c0.7-0.7,1.5-1.5,2.3-2.3c-1.9-0.5-3.7-1-5.5-1.5c-0.2-0.1-0.4,0-0.5,0.1C22.1,38.9,21.4,39.5,20.5,40.2z  M24.8,25.4c-1.9-0.5-3.7-1-5.5-1.5c-0.1,0-0.3,0-0.4,0.1c-0.8,0.6-1.5,1.3-2.4,2c2,0.6,3.8,1.2,5.7,1.7c0.1,0,0.3-0.1,0.4-0.1 C23.4,26.8,24.1,26.1,24.8,25.4z M32.2,36.3c-0.1-0.1-0.1-0.1-0.2-0.1c-1.7-0.5-3.5-1-5.2-1.5c-0.2,0-0.4,0-0.5,0.1 c-0.8,0.6-1.5,1.3-2.4,2c2,0.6,3.8,1.1,5.7,1.7c0.1,0,0.3,0,0.4-0.1C30.8,37.7,31.5,37,32.2,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,56.8c-0.8-1.2-1.7-2.4-2.5-3.6c-1-1.6-1-3.2-0.3-4.9 c0.5-1.3,1.3-2.3,2.2-3.3c9-9,18.1-18.1,27.1-27.1c0.9-0.9,1.9-1.7,2.9-2.4c1.7-1.2,3.3-0.9,4.7,0.5c0.1,0.1,0.2,0.3,0.2,0.5 c0.1,1,0.3,1.9,0.4,2.9c0.2,1.8-0.4,3.5-1.1,5c-1.9,4.5-4.7,8.4-8.5,11.5c-7.5,6.2-14.9,12.6-22.3,18.9c-0.4,0.3-0.8,0.6-1.2,0.9 C29.3,56,28.8,56.4,28.4,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,13.3c-1.9,0.2-3.3,1.3-4.5,2.5c-0.5,0.5-1,0.6-1.6,0.4 c-7.3-2-14.7-4-22-5.9c-0.1,0-0.2-0.1-0.3-0.1c2.4-2.8,5.6-4,9.3-2.5c1.8,0.7,3.7,1.1,5.5,1.7c4.4,1.3,8.8,2.5,13.1,3.8 C59.1,13.2,59.2,13.2,59.5,13.3z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "doc",
    viewBox: "0 0 64 64"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#146CC6",
    d: "M56.412,18.499l0.292,37.982c0.157,0.727,0.157,2.043-0.729,2.926c-0.868,0.882-2.048,1.022-2.917,1.022             H19.8c-0.876,0-2.048-0.141-2.776-1.022c-0.738-0.883-0.886-2.043-0.738-2.926l0.441-47.616c0-2.484,1.467-5.116,5.563-5.116h19.488             L56.412,18.499z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_d",
    gradientUnits: "userSpaceOnUse",
    x1: 19.7769,
    y1: 835.7275,
    x2: 19.7769,
    y2: 781.9756,
    gradientTransform: "matrix(1 0 0 1 16.7998 -776.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEEEEE"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_d)",
    d: "M47.628,19.815c-3.366,0-7.325-0.875-7.325-5.696V5.361H22.291c-3.221,0-4.096,1.896-4.096,3.791             l-0.442,47.626c-0.148,1.747,0.443,2.336,2.196,2.336c11.717,0,21.534,0,33.25,0c1.754,0,2.344-0.727,2.204-2.477l-0.292-36.674             L47.628,19.815z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "doc_d",
    viewBox: "0 0 64 64"
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doc",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "doc_p",
    viewBox: "0 0 64 64"
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doc",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    style: {
      fill: "#2DB053"
    },
    width: 48,
    height: 48,
    x: 1,
    y: 16
  })), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "btn_95v",
    viewBox: "0 0 222 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi1_)",
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M32,61C16,61,3,48,3,32S16,3,32,3h158c16,0,29,13,29,29s-13,29-29,29H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi2)",
    d: "M32,33c-12,0-21-6-21-14S20,5,32,5h154c12,0,21,6,21,14s-9,14-21,14H32z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "btn_135v",
    viewBox: "0 0 315 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi1_)",
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M32,61C16,61,3,48,3,32S16,3,32,3h250c16,0,29,13,29,29s-13,29-29,29H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi2)",
    d: "M32,33c-12,0-21-6-21-14S20,5,32,5h244c12,0,21,6,21,14s-9,14-21,14H32z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "btn_155v",
    viewBox: "0 0 362 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi1_)",
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M32,61C16,61,3,48,3,32S16,3,32,3h298c16,0,29,13,29,29s-13,29-29,29H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi2)",
    d: "M32,33c-12,0-21-6-21-14S20,5,32,5h284c12,0,21,6,21,14s-9,14-21,14H32z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "btn_185v",
    viewBox: "0 0 432 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi1_)",
    stroke: "#6748a9",
    strokeWidth: 4,
    strokeOpacity: 1,
    d: "M32,61C16,61,3,48,3,32S16,3,32,3h368c16,0,29,13,29,29s-13,29-29,29H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vi2)",
    d: "M32,33c-12,0-21-6-21-14S20,5,32,5h354c12,0,21,6,21,14s-9,14-21,14H32z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_100",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,62c-0.3,0-0.5,0-0.8-0.1L4.5,49.9C3.6,49.6,3,48.7,3,47.7V18.7c0-0.8,0.4-1.6,1.2-2L29.3,2.3C29.6,2.1,30,2,30.4,2             c0.3,0,0.5,0,0.8,0.1l29.4,10.4c0.9,0.3,1.5,1.2,1.5,2.2v24.8c0,0.6-0.3,1.2-0.7,1.7L40.6,61.3C40.1,61.8,39.6,62,39,62z M41.6,53.2             L57,38.3V19.9L41.6,30.7V53.2z M38.5,26.6l15.4-10.8L30.6,7.5L12.2,18L38.5,26.6z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_101",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2,38.2l8.6-25.7c0.2-0.7,0.1-1.6-0.3-2.2c-0.5-0.6-1.2-1-2-1H13.9c-1.6-5.4-3-6-3.6-6.3C9.2,2.4,8.2,2,7.1,2             C5.4,2,4.3,3,3.5,3.8C2.4,5,1.6,5.9,2.2,7.4c0.4,0.9,1.3,1.5,2.2,1.5c1,0,1.5-0.5,2.5-1.5c0.1-0.1,0.2-0.1,0.2-0.2             c0.1,0.1,0.2,0.2,0.4,0.2c0.3,0.8,0.9,2.5,1.4,4l9.8,35.5c-1.6,1.6-2.6,3.8-2.6,6.3c0,4.8,3.9,8.8,8.7,8.8c4.8,0,8.7-3.9,8.7-8.8             c0-1.4-0.3-2.7-0.9-3.9h7.8c-0.6,1.2-0.9,2.5-0.9,3.9c0,4.8,3.9,8.8,8.7,8.8c4.8,0,8.7-3.9,8.7-8.8c0-3.3-1.8-6.2-4.5-7.7             c-0.1-0.2-0.3-0.5-0.4-0.7c-0.5-0.5-1.1-0.8-1.8-0.8H23.5l-1.2-4.3h27.6C50.9,39.8,51.9,39.2,52.2,38.2z M48.3,49.5             c2,0,3.6,1.7,3.6,3.7c0,2-1.6,3.7-3.6,3.7c-2,0-3.6-1.7-3.6-3.7C44.7,51.2,46.3,49.5,48.3,49.5z M24.9,49.5c2,0,3.6,1.7,3.6,3.7             c0,2-1.6,3.7-3.6,3.7c-2,0-3.6-1.7-3.6-3.7C21.3,51.2,22.9,49.5,24.9,49.5z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_102",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9,24.5c-15.6,0-34.6,0-50.3,0c-0.5,0-1.1,0-1.8,0 c0.8,11.7,6.5,19.6,17.1,24.1c-0.1,0.4-0.2,0.7-0.3,1.1c-0.2,1.1,0.2,1.6,1.3,1.6c5,0,10,0,15,0c1.5,0,1.8-0.6,1.2-2.6 c0.5-0.2,0.9-0.4,1.4-0.6c8.7-3.9,13.8-10.5,15.5-19.8L55.9,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,21c8.7,0,17.4,0,26.1,0c1.9,0,2.9-1.2,2.5-3c-0.2-1.1-0.9-1.7-2-1.8 c-0.2,0-0.4,0-0.6,0c-17.4,0-34.8,0-52.1,0C1.9,16.2,1,17,1,18.6C1,20.2,1.9,21,3.5,21c5.1,0,10.1,0,15.2,0C22.4,21,26,21,29.7,21 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7,12.7c4.6,0,9.2,0,13.8,0c0.3,0,0.7,0,1-0.2c2-1,4.1-2.1,6.1-3.2 c1-0.6,1.6-2.1,1.4-3.2c-0.3-1.7-1.5-2.5-3.3-2c-1.1,0.3-2.1,0.7-3.1,1.2c-5.3,2.4-10.6,4.8-15.8,7.3 C40.7,12.6,40.7,12.7,40.7,12.7z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_103",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5,34.9c0,0-1.4,1.6-1.8,1.9c-2.4,1.9-9.8,5.9-12.6,3.1             c-0.8,3.7-8,10.8-12.8,10.8c-1.4,0,1,0,0,0c-4,0-9.6-0.9-12.7-3.5c-4.2-3.6-7.4-8.4-12.6-7.7c-6.3,0.9-12.2-3.7-12.2-3.7L6,12             c0,0,4.7,1.1,7.8,2c5.9,1.6,5.9,4.3,12.6,3.7c4.7-0.4,8.6-0.2,13.2,1.1c3.5,1,6.2-2.3,9.4-3.7c2-0.9,6-2.4,6-2.4L64.5,34.9z              M30.5,42.1c1.8,0.2,5.6,5,6.9,4.4c-1.1-2.2-8.8-5.3-5.6-8.2c2-1.8,10,6.1,10,6.1c0.4-2.9-9.6-6.3-6.8-9.8c2.9-3.7,9.2,9.1,11.3,6.8             c1.1-1.2-9.7-12.4-12-12.8c-4.2-0.7-7.1,6.1-11.5,2.6c-3-2.4-1.4-6.7-0.2-9.5c-5.6,0.1-5.4,7.4-6.6,12.3             c-0.4,1.7,12.3,12.1,14.7,12.1C30.7,46.1,27.8,41.7,30.5,42.1C31.1,42.2,30.4,42.1,30.5,42.1z M46.1,20.7c-0.8,2.2,3.1,7.7,3.9,9.7             c2.9,6.6,1.8,7.1,8.7,4.2c2.6-1.1-2.8-10-3.8-12.3C52.3,16.3,51.9,17.9,46.1,20.7C46.1,20.7,48.1,19.7,46.1,20.7             C45.8,21.5,47.8,19.9,46.1,20.7z M33.7,24.4c3.7,0,14.4,8.9,14.5,12c-0.1-4.4-4.4-12.8-9-13.9c-3.8-0.9-7.8-2-11.8-1.1             c-1.2,0.2-3.4,6.6-2,6.6C28.5,28,30.3,24.4,33.7,24.4z M3.9,33.7c1.1,0,7.3,2.8,7.6,1.5c1.3-5.5,2.9-10.8,4.3-16.3             c0.1-1-6.9-2.7-7.3-2.1C6.2,20.1,4.1,29.6,3.9,33.7C4.4,33.7,4,32.6,3.9,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,30.4c1.4,0,2.5,1.2,2.4,2.6c-0.1,1.3-1.2,2.4-2.6,2.3             c-1.3-0.1-2.4-1.2-2.4-2.5C53.2,31.4,54.3,30.4,55.7,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,34.5c-1.4,0-2.5-1-2.5-2.4c-0.1-1.4,1.1-2.6,2.5-2.6c1.3,0,2.5,1.1,2.5,2.4             C10.6,33.4,9.5,34.5,8.2,34.5z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_104",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,41.1c0-2.3,0-4.5,0-6.8c0-1.5,0.4-2.1,1.8-2.6c4-1.5,8-2.9,12-4.4             c0.5-0.2,0.6-0.4,0.6-0.9c0-4.2,0-8.4,0-12.7c0-1.4,0.4-2,1.7-2.4c4.6-1.7,9.1-3.3,13.7-5c0.8-0.3,1.5-0.3,2.2,0             c4.6,1.7,9.2,3.3,13.7,5c1.3,0.5,1.7,1,1.7,2.4c0,4.2,0,8.5,0,12.7c0,0.4,0.1,0.6,0.5,0.8c4.1,1.5,8.1,2.9,12.2,4.4             c1.4,0.5,1.8,1.1,1.8,2.6c0,4.6,0,9.1,0,13.7c0,1.3-0.4,1.9-1.6,2.3c-4.6,1.9-9.2,3.7-13.8,5.6c-0.8,0.3-1.5,0.3-2.3,0             c-4.3-1.8-8.6-3.5-12.9-5.2c-0.3-0.1-0.7-0.1-1,0c-4.3,1.7-8.6,3.4-12.8,5.2c-0.8,0.3-1.5,0.3-2.3,0c-4.5-1.9-9-3.7-13.5-5.5             C1.3,49.8,1,49.3,1,47.7C1,45.5,1,43.3,1,41.1C1,41.1,1,41.1,1,41.1z M44.5,16.5c-0.2,0.1-0.3,0.1-0.4,0.1c-3.2,1.3-6.4,2.6-9.6,3.9             c-0.3,0.1-0.4,0.3-0.4,0.6c0,2.6,0,5.2,0,7.9c0,0.6,0,1.2,0,1.8c0.1,0,0.2,0,0.3,0c3.3-1.2,6.5-2.4,9.8-3.6c0.4-0.1,0.4-0.4,0.4-0.7             c0-3.1,0-6.1,0-9.2C44.5,17.1,44.5,16.8,44.5,16.5z M48.5,51.2c3.4-1.4,6.7-2.7,10-4.1c0.4-0.1,0.4-0.4,0.4-0.7c0-1.6,0-3.3,0-4.9             c0-1.5,0-3.1,0-4.6c-0.2,0-0.3,0.1-0.4,0.1c-3.2,1.3-6.4,2.6-9.6,3.9c-0.4,0.2-0.4,0.4-0.4,0.7c0,2.3,0,4.6,0,6.9             C48.5,49.4,48.5,50.2,48.5,51.2z M30,36.9c-0.1,0-0.2,0-0.2,0c-3.3,1.3-6.6,2.7-9.8,4c-0.3,0.1-0.4,0.4-0.4,0.7c0,1.7,0,3.3,0,5             c0,1.5,0,3,0,4.6c0.3-0.1,0.5-0.2,0.7-0.3c2.7-1.1,5.3-2.2,8-3.2c0.5-0.2,1.3-0.3,1.5-0.7c0.3-0.4,0.1-1.1,0.1-1.7             C30,42.5,30,39.7,30,36.9z M23.2,13.6c3,1.2,5.8,2.4,8.6,3.5c0.2,0.1,0.4,0,0.6-0.1c2-0.8,4.1-1.6,6.1-2.5c0.7-0.3,1.4-0.6,2.2-0.9             c-0.1-0.1-0.2-0.1-0.3-0.2c-2.7-1-5.4-2-8.2-3c-0.2-0.1-0.5,0-0.7,0c-1.2,0.4-2.3,0.8-3.5,1.3C26.5,12.3,24.9,12.9,23.2,13.6z              M26.3,33.9c-3-1.1-5.8-2.1-8.6-3.1c-0.2-0.1-0.4,0-0.6,0.1c-2.1,0.7-4.1,1.5-6.2,2.2c-0.7,0.2-1.4,0.5-2.1,0.8C8.9,34,8.9,34,9,34             c2.8,1.1,5.5,2.2,8.3,3.3c0.2,0.1,0.5,0,0.7,0c1.2-0.5,2.3-0.9,3.5-1.4C23,35.3,24.6,34.7,26.3,33.9z M55.2,34             c-0.1-0.1-0.2-0.1-0.2-0.1c-2.7-1-5.5-2-8.2-3c-0.2-0.1-0.5,0-0.7,0c-1.5,0.5-3,1.1-4.5,1.6c-1.3,0.5-2.5,0.9-3.8,1.4             c0.1,0.1,0.2,0.1,0.2,0.2c2.7,1.1,5.5,2.2,8.2,3.3c0.2,0.1,0.5,0,0.7,0c1.9-0.7,3.7-1.5,5.5-2.2C53.3,34.7,54.3,34.4,55.2,34z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_200",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,63c-9.3,0-27.6,1.6-27.9-12.3C5.8,39.5,12.9,31,19.6,22.8c0.3-0.4,1.2-1.1,1.3-1.6c-1.3-0.8-1.2-2.6-0.5-3.7 c1-1-0.9-2.4-1.7-3.5c-1.2-1.6-2.3-3.3-3.1-5.1C14.5,6.6,15,3.7,17,2c2.7-2.3,7.3-0.4,10.1,0.7c3,1.1,4.9-1.1,8-1.6 c1.6-0.2,3.3-0.2,4.5,0.8c0.6,0.5,1.2,1.1,1.7,1.8c1.2,1.5,1.4,0.9,3.2,0.6c2.5-0.4,5.3-0.4,6.9,1.9c2.4,3.5-2,6.5-4.3,8.3 c1.5-0.5,3.3-1.5,4.7-0.2c2.2,2.2-0.7,3.9-2.5,4.7c1.5,1.2,8.7,5.7,4.3,7.8c-2.3,1.1-6.2-2.9-8.2-4.1c6.8,8.2,13.9,17.7,13.3,28.9 C58.1,63.9,42.9,63,34,63z M22.9,26.7c-3.2,4-6.7,7.8-9,12.5c-2,4.2-5,11.2-1.1,15c3.9,3.8,8.1,3.3,13.2,3.4 c6.7,0.2,13.5,0.3,20.3-0.3c12.8-1.2,4.8-17.2,0.8-23.2c-1.9-2.6-3.8-5.2-5.8-7.7c-1.2-1.6-2.5-3.1-3.7-4.7 c-1.6,0.2-3.2,0.5-4.8,0.5c-1.6,0-5.4-1-6.4,0.2C25.2,23.9,24.1,25.3,22.9,26.7z M29.4,16.7c2.4,0,4.6-0.1,7-0.3 c2.9-0.3,6-5.2,8.5-6.9c-1.7,0.3-4,1.4-5.6,0.2c-2.4-1.9-2-4.3-5.5-2.9c-2.4,1-4.2,2.5-6.8,1.4c-2.1-0.9-4.5-1.9-6.8-2 c-0.7,0.7,2.4,4.5,2.8,5C24.8,13.6,26.3,16.7,29.4,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,55v-3.5c-2.4-0.1-4.8-0.8-6.1-1.5l1.1-4.2c1.5,0.8,3.6,1.6,6,1.6c2.1,0,3.5-0.8,3.5-2.2c0-1.4-1.2-2.2-3.9-3.1 c-3.9-1.3-6.5-3.1-6.5-6.6c0-3.2,2.2-5.7,6.1-6.4v-3.4h3.5v3.2c2.4,0.1,4,0.6,5.3,1.2l-1.1,4.1c-0.9-0.4-2.6-1.3-5.2-1.3 c-2.3,0-3.1,1-3.1,2.1c0,1.2,1.3,1.9,4.3,3.1c4.3,1.5,6,3.5,6,6.8c0,3.2-2.2,5.9-6.4,6.6V55H30.8z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_201",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fldr",
    transform: "rotate(20,32,32)",
    width: 76,
    height: 76,
    x: -10,
    y: -8
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_202",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9,8c-0.2-2.2,0.3-5.1-2.3-6C25.5,1.4,23.3,1,21.2,1c-1.7,0-3.3-0.1-4.9,0.3             c-1.3,0.3-3.3,0.4-4.4,1.4C10.8,3.8,11,6,10.9,7.4c-0.5,6.4-3.2,15.7,2.7,20.3c1.2,0.9,2.3,1.6,2.3,3.3c0.1,1.7-0.3,3.4-0.4,5.1             c-0.3,4-0.6,8.1-0.7,12.1C14.8,52.6,14.1,63,20.6,63c6.6,0,5.4-12.6,5.2-16.7c-0.2-4-0.5-8-0.8-12.1c-0.1-1.5-0.7-3.6,0.1-4.9             c0.5-0.8,1.6-1.2,2.3-1.9C32.8,22.6,30.4,14.3,29.9,8C29.9,7.1,30.2,11.1,29.9,8z M20.9,29.7c0.1,3.7,0.4,7.4,0.6,11.1             c0.2,4.4,0.9,9.1,0.4,13.5c-0.1,0.7-1.2,7.3-2.4,3.9c-0.6-1.1-0.4-2.7-0.4-3.9c-0.1-2.4-0.2-4.8-0.2-7.1c-0.1-4.2,0.2-8.4,0.6-12.6             c0.1-1.8,0.6-3.8,0.3-5.6c-0.4-1.8-1.9-2.8-3.3-3.9c-3.3-2.5-2.5-6.1-2.3-9.7c0.1-2-0.5-10.1,1.9-10.1c0,2.2,0,4.3,0,6.5             c0,0.9-0.4,9.4,3.2,5.9c1-0.9,0.6-3.6,0.6-4.8c0-2.3,0-4.7,0-7c0-0.4-0.2-0.9,0.3-0.9c1.6,0,0.8,3.1,0.8,4.4c0,2.3-0.5,5.1,0.1,7.4             c0.3,1.3,2.1,1.9,3.1,0.9c1.3-1.3,0.5-4.8,0.6-6.6c0-1.9,0-3.8,0-5.8c2.1,0.1,1.6,4.7,1.7,6.4c0.2,2.6,0.8,5.3,0.6,8             c-0.1,1.9-0.7,3.7-2.1,5.1C23.3,26.3,20.8,26.9,20.9,29.7C21,30.5,20.9,28.2,20.9,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6,11.6c-0.8-2.3-2.1-4.5-3.7-6.3c-0.9-1-1.9-1.8-3-2.5             c-0.8-0.5-2.1-0.9-2.8-1.5c-3.5-3.2-2.8,9.1-2.8,10.2c0.1,7.2,0.1,14.3-0.2,21.5c-0.4,6.9-1,13.9-0.8,20.8c0.1,3.2-0.2,10.8,5.2,9             c5.7-1.8,5.9-10.9,5.6-15.7c-0.2-3-0.7-6.3-1.9-9.1c-1.3-3.1,0.6-5.8,2-8.4C53.2,23.7,55,18.1,52.6,11.6             C50.9,6.8,54.4,16.6,52.6,11.6z M45.4,30.3c-1.9,3.4-1.7,6.5-0.4,10.1c1.1,3.2,1.5,6.6,1.2,9.9c-0.1,1.3-0.7,8.7-2.6,8.7             c-1.1,0-0.6-7.4-0.6-8.4c0.1-7,0.7-14,0.9-21.1c0.3-7.8,0.1-15.6,0.1-23.4c3.4,2.3,5.4,6.5,5.8,10.5C50.4,21.8,47.8,26,45.4,30.3z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_203",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4,1c1.6,0.4,3.1,2.5,4.2,3.7c2.2,2.3,2.2,2.2,5.3,1.4c1.6-0.4,4.9-2,6.2-0.3c1.3,1.8,1.6,5.3,2.2,7.4 c0.7,2.6,10.1,0.5,8.7,5c-0.5,1.7-2.2,5.4-1.7,7.1c0.4,1.6,3.7,3.9,4.9,5c1.9,2.1-0.4,3.8-1.8,5.3c-1.8,1.8-3.3,2.4-2.6,4.9 c0.5,1.7,2.2,5.3,1.3,7c-1,1.7-4.8,2-6.6,2.4c-5,1.4-1.1,10.3-7.8,8.6c-1.1-0.3-5.2-2-6.1-1.2c-1.9,1.9-3.7,4.1-6,5.5 c-3.9,0-4.7-6.5-8.9-5.3c-1.7,0.5-5.2,2.1-6.9,1.2c-1.7-0.9-2-4.9-2.4-6.6c-1.1-3.9-8.9-1.7-9.2-5.4c-0.2-2.3,1.3-5.3,1.8-7.6 c0.5-0.9-3.3-3.8-3.9-4.5c-1.3-1.4-2.6-2.7-0.9-4.4c1.1-1.2,4.8-3.7,4.8-5.4c-0.5-2.1-2.2-5.8-1.7-7.9c0.5-2.1,5.1-2.4,6.7-2.8 c4.9-1.3,1.3-10.4,7.8-8.7c2.7,0.7,5.1,2.2,7.2,0C28.3,4,30.3,1,32.4,1C33.5,1.3,32.1,1,32.4,1z M33.6,41.5 c0.2,10.2,15.9,10.4,15.9,0.1C49.5,31.3,33.6,31.3,33.6,41.5C33.7,45.9,33.6,37.1,33.6,41.5z M30.4,22.6 c0.2-10.3-15.8-10.5-16-0.2C14.4,32.7,30.2,32.9,30.4,22.6C30.5,18.3,30.3,26.9,30.4,22.6z M45.6,21.2c-0.6-7.7-10.8,4.6-12.4,6.2 c-2.3,2.3-4.7,4.7-7,7c-2.2,2.2-6.3,5-7.6,7.8c-1,2.4,2.1,4.3,4,2.6c2.7-2.7,5.5-5.5,8.2-8.2C35.7,31.7,41.8,26.9,45.6,21.2 C45.5,19.9,45.4,21.5,45.6,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,39.4c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.1,2.7-2.6,2.7c-1.6,0-2.7-1.1-2.7-2.7C39.4,40.6,40.6,39.4,42.1,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,24.6c-1.4,0-2.7-1.3-2.6-2.8c0.1-1.4,1.3-2.6,2.7-2.5c1.5,0,2.6,1.2,2.6,2.7C24.5,23.4,23.4,24.6,21.9,24.6z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_220",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3,52.9c5.3,2.1,11.6,2.9,17.3,2.7c1.7,0,6.2,0.3,7.4-0.9c1.4-2.9,2.8-5.9,4.3-8.8c2.8-5.8,5.8-11.6,8.5-17.5 c1.4-2.8,2.7-5.5,4.1-8.3c1.2-2.4,2.5-7.6,4.7-9.2c3.1-2.3,1,3.7,0.7,4.2c-1.3,2.7-2.7,5.4-4,8.1c-2.7,5.6-5.5,11.2-8.2,16.8 c-2.7,5.5-5.4,11-8.1,16.5c-1,2-5.8,1.6-7.6,1.7c-3.2,0.2-6.3-0.4-9.5-0.4c6,2,12.2,3,18.5,3.3c3.8,0.2,3.7-1.5,5.3-4.7 c1.7-3.5,3.4-6.9,5.1-10.4c2.8-5.7,5.5-11.3,8.3-17c0.6-1.1,2-5.4,3.8-3c0.9,1.9-3.3,8.2-4.2,10c-2.7,5.6-5.4,11.2-8.2,16.8 c-1.4,2.9-2.9,5.8-4.2,8.7c-1.6,3.4-4.6,2.4-8,2.1c-12.2-1-25.2-4.9-35-12.4c-2.7-2.1-1.6-3.2-0.2-5.9c1.4-2.7,2.7-5.4,4.1-8.1 c3-6.1,6-12.3,9-18.4c1.4-2.9,2.9-5.8,4.3-8.7c1.6-3.2,3.8-2.5,7.1-2.6c7-0.2,14-1.1,20.6-3.3c1.5-0.5,4.9-3,6.3-1.8 c1.3,1.3-1.3,5-2,6.3c-2.9,6-5.8,11.9-8.8,17.9C41,32,38.3,37.4,35.6,42.9c-1.1,2.2-2,5.7-3.7,7.4c-1.8,1.8-6.2,2.3-8.7,2.6 C19.5,53.4,16,52.9,12.3,52.9z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_230",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,40.4c1.4,1.4,2.8,2.8,4.2,4.2c6-6,12.1-12.1,18.2-18.2             c2.2,2.2,4.4,4.4,6.6,6.6c6.6-6.6,13.2-13.2,19.9-19.9c1.2,1.3,2.5,2.5,3.7,3.8c1.3-5.4,2.6-10.7,3.9-16c-5.4,1.3-10.6,2.6-16,3.9             c1.4,1.4,2.7,2.7,4,4C43.3,14,38.2,19.2,33,24.4c-2.1-2.1-4.3-4.3-6.4-6.4C19,25.5,11.5,33,4,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,63c2.7,0,5.3,0,8,0c0-12.3,0-24.5,0-36.8c-2.7,0-5.3,0-8,0C50,38.4,50,50.7,50,63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,33.5c0,9.9,0,19.7,0,29.5c2.7,0,5.3,0,8,0c0-9.8,0-19.7,0-29.5C41.8,33.5,39.1,33.5,36.4,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,63c2.7,0,5.4,0,8,0c0-7.4,0-14.7,0-22.1c-0.1,0-0.3,0-0.4,0c-2.4,0-4.8,0-7.2,0c-0.3,0-0.4,0.1-0.4,0.4             c0,7.1,0,14.2,0,21.2C22.4,62.7,22.4,62.8,22.4,63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,63c2.7,0,5.4,0,8,0c0-4.9,0-9.8,0-14.7c-0.1,0-0.3,0-0.4,0c-2.4,0-4.8,0-7.2,0c-0.3,0-0.4,0.1-0.4,0.4c0,4.7,0,9.4,0,14C9,62.8,9,62.9,9,63z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_250",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2,12.2c-2.8,0-5.2,2.3-5.2,5.1v31c0,2.8,2.3,5.1,5.2,5.1h51.7c2.8,0,5.1-2.3,5.1-5.1v-31c0.1-2.8-2.2-5.1-5-5.1H6.2z  M58.1,16c0.7,0,1.3,0.6,1.3,1.3v31.1h-0.2c0,0.7-0.6,1.3-1.3,1.3H6.2c-0.7,0-1.3-0.6-1.3-1.3V17.3c0-0.7,0.6-1.3,1.3-1.3H58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,47.9c-0.5-0.1-0.9-3.6-1.1-4.4c-0.8,0.1-4.7,0.6-4.9-0.4c-0.1-0.7,3.3-5,3.8-5.6c1.4-1.5,3.7-5.1,3.7-5.1 s-2.5,0.8-3.2,1c-1.7,0.3-4,0.4-5.3-1c-2.1-2.3-0.1-6.4-0.5-9.1c-1.3-9.7,9.9-3.4,13.5-0.2c1-0.5,2.2-0.5,3.2-0.1 c3.1-2.6,6.6-4.9,10.8-4.9c2.4,0.4,3.4,0.9,2.7,6.8c0.3,2.4,0.3,2.5,0.3,5c0,0.1,0-0.4,0,0c-0.6,4.7-5.6,4-9,2.7 c0.8,1.6,2.6,4.3,3.8,5.6c0.6,0.7,4.3,4.2,4.1,4.8c-0.1,0.8-4.4,0.3-5.1,0.3c0,0-0.2,4.2-1.2,4.6c-0.5,0.2-4.8-3.9-8-13.4 C37.2,44.1,33.3,48,33,47.9z M37.5,25.4c-0.1-1-1.4-1.6-1.4-1.6s-1.8-1.2-3.4-2.1c-1.4-0.8-3.9-1.6-4.6-0.9c-0.5,0.5-0.1,3.1-0.1,4 c0.1,1.7-1.6,5.9,0.8,6.3c2.3,0.4,5.7-0.4,8.3-2.7c0.2-0.3,0.4-1,0.2-1.2c-2.1-0.3-4.5-0.5-4.7-1.7C32.3,23.6,37.5,25.4,37.5,25.4z  M44.2,28.2c2.3,2.3,4.3,3,7.5,3.1c2.8-0.1,1.9-3,1.8-6.1c-0.1-1.8,0.5-3.7-0.4-4.3c-1.5-0.9-4.1,0.4-4.6,0.6 c-1.9,0.8-2.5,1.4-4.1,2.7c-0.3,0.4-0.2,1-0.2,1s4.6-1.7,5-0.5c0.5,1.3-1.4,2.1-4.9,2.3C44,27.1,44.2,28.2,44.2,28.2z M30.5,41.5 c1.5-0.5,2.7-0.4,2.7-0.4s0.9,0.2,0.6,2.9c2.8-4.7,4.8-8.1,5.9-14.1c-0.2-0.1-0.2-0.1-0.6-0.3c-0.1,0.1,0.4,0.2,0,0 c-1.1,0.9-1.1,0.9-1.8,1.6C37.4,31.2,34.7,36.5,30.5,41.5z M42.1,29.6c-0.3,0.1-0.3,0.1-0.6,0.2c1.4,6.1,2.5,9.2,6,14.1 c0-1.7,0.4-2.9,0.4-2.9s0.8-0.4,2.5,0c-1.8-1.8-4.9-6.3-6.1-9C43.9,31.3,42.1,29.6,42.1,29.6z M39.2,26.2c0,2.1,1,2.1,1.7,2 c0.6,0,1.5,0,1.5-2c0-1.3-0.7-1.7-1.6-1.7C39.8,24.5,39.1,24.9,39.2,26.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 26.5,
    width: 24,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 26.5,
    width: 7,
    height: 3.7
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_251",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,61.6c-1-0.3-1.7-7-2.1-8.4c-1.5,0.2-9,1.1-9.4-0.7c-0.2-1.3,6.4-9.6,7.4-10.8c2.6-3,7.1-9.8,7.1-9.8 s-4.9,1.6-6.2,1.9c-3.4,0.6-7.6,0.8-10.2-2C-0.2,27.3,3.7,19.5,3,14.2C0.5-4.5,22.1,7.7,29,13.8c2-0.9,4.3-1,6.3-0.1 c6-5,12.7-9.5,20.9-9.5c4.5,0.7,6.5,1.7,5.3,13.2C62,22.1,62,22.2,62,27c0,0.1,0-0.7,0,0c-1.1,9.1-10.9,7.7-17.4,5.2 c1.5,3,5.1,8.2,7.3,10.8c1.1,1.3,8.2,8.2,8,9.3c-0.3,1.5-8.6,0.6-9.8,0.6c0,0-0.4,8.1-2.4,8.9c-0.9,0.3-9.3-7.5-15.4-25.9 C25.4,54.2,18,61.7,17.4,61.6z M26.1,18.1c-0.2-2-2.7-3.2-2.7-3.2s-3.4-2.4-6.6-4c-2.7-1.5-7.5-3-8.8-1.8c-1,0.9-0.3,5.9-0.2,7.7 C8,20.2,4.7,28.3,9.5,29.1c4.4,0.8,11-0.7,16-5.2c0.5-0.7,0.8-1.9,0.4-2.2c-4.1-0.5-8.7-1-9.2-3.3C16,14.7,26.1,18.1,26.1,18.1z  M39,23.6c4.5,4.4,8.3,5.7,14.5,6c5.5-0.1,3.6-5.8,3.4-11.8c-0.2-3.4,1-7.1-0.8-8.3c-2.9-1.8-8,0.8-8.8,1.2 c-3.7,1.5-4.9,2.7-7.9,5.3c-0.6,0.7-0.4,1.9-0.4,1.9s8.8-3.3,9.7-1c1,2.6-2.7,4-9.5,4.4C38.6,21.3,39,23.6,39,23.6z M12.6,49.2 c2.9-1,5.3-0.8,5.3-0.8s1.7,0.3,1.2,5.5c5.3-9,9.2-15.7,11.4-27.2c-0.4-0.2-0.4-0.2-1.2-0.6c-0.3,0.2,0.7,0.4,0,0 c-2.1,1.8-2.1,1.8-3.5,3.1C25.9,29.3,20.7,39.5,12.6,49.2z M35,26.2c-0.7,0.3-0.7,0.3-1.1,0.4c2.8,11.8,4.9,17.7,11.5,27.2 c0-3.2,0.8-5.6,0.8-5.6s1.6-0.7,4.8,0.1c-3.4-3.5-9.4-12.3-11.9-17.4C38.5,29.5,35,26.2,35,26.2z M29.3,19.6c0.1,4,2,4,3.2,3.9 c1.2-0.1,3,0,2.9-3.9c0-2.6-1.4-3.3-3.1-3.2C30.5,16.4,29.3,17.2,29.3,19.6z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_300",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8,51c-1-1-5.1-3.1-6.1-1.1c-0.2,0.4-1.2,3.4-1.7,3.1c-1.5-0.2-3-0.5-4.5-0.7c-0.9,0-0.2-5.4-2.8-5.8 c-1-0.1-3.1,1.2-4,1.6c-0.8,0.3-2.4-3-2.9-3.7c-0.4-0.7,0.9-1.9,1.3-2.4c1-1.3,0.8-1.8,0.2-3.3c-0.6-1.5-1.9-1.6-3.4-2.1 c-0.7-0.4,0-3.4,0.1-4.2c0.2-2,1.9-1.5,3.6-1.8c0.6,0,1.3-1.9,1.6-2.4c0.5-0.5-0.5-2.3-0.7-2.8c-0.6-1.8,1.3-1.9,2.7-2.7 c2.6-1.4,4.1,3.3,6.9,0.5c0.4-0.7,1.1-3.2,2-3.2c1.5,0.2,3,0.4,4.5,0.6c0.7,0,0.8,2.6,0.9,3.2c0,0.6,2.1,1.8,2.6,1.6 c0.8-0.3,2.9-1.6,3.6-1.4c0.9,0.3,2.4,3.3,3,4.2c0.5,1-1.9,2.5-1.9,3.6c0.3,2,0.2,2.2,2.2,3c1.5,0.7,2.1,0.5,1.8,2.2 c-0.1,0.8-0.1,3.4-0.7,4c-0.6,0.6-2.9,0.7-3.8,0.9c-0.6,0.2-1.6,2-1.3,2.6c0.2,0.5,1.4,3.3,0.7,3.5C56.5,48.8,54.3,49.6,53.8,51z  M45.7,43.8c3.6,0,7.1-2,7.9-5.8c0.8-3.9-2-7.6-5.8-8.4c-3.9-0.8-8.1,1.6-8.9,5.6C37.9,39.6,41.4,43.6,45.7,43.8 C47.5,43.8,43.4,43.7,45.7,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,31.9c0,2.4-2.4,3.2-0.1,5.5c0.8,0.3,2.8,0.3,3.2,1.1c0.2,0.8,1.1,3.1,0.8,3.8c-0.3,0.7-2.3,1.4-2.9,1.8 c-1.4,0.7-1.7,2-1,3.2c0.9,1.5,1.4,1.6,0.2,2.9c-0.4,0.4-1.8,2.7-2.4,2.3c-0.6-0.3-2.4-1.6-3.1-1.2c-0.6,0.2-2.2,0.5-2.2,1.3 c-0.2,0.8-0.2,2.7-0.9,3.2c-0.5,0.1-4.4,0.9-4.4,0.3c-0.4-1.1-0.8-2.3-1.2-3.4c-0.2-0.7-2.3-0.9-2.9-0.6c-0.4,0.3-2.4,2.2-2.9,1.7 c-0.7-0.6-3.2-2.1-3.4-3c-0.3-1.9,2.9-3.8-0.3-5.2c-1.5-0.7-2.7-0.3-2.9-2.1C0.6,42-0.1,40.7,1.7,40c1.8-0.7,3.7-2,2.5-4.2 c-0.3-0.5-1.6-2.1-1.1-2.7c0.6-0.8,2-3.1,3-3.4c0.6-0.2,2.7,1.2,3.2,1.5c0.5,0.3,2.4-0.8,2.4-1.4c0.5-1.5,0.3-2.9,2.1-3.1 c0.7-0.1,3.5-0.8,3.9,0c0.9,2.1,1.6,5.1,4.6,3.3c1.5-0.9,1.5-1.4,2.8-0.2C25.7,30.4,27,31.6,27.2,31.9z M15.3,34.6 c-8.3,0-8.2,12.3-0.4,13.3C24.1,49.3,24.4,34.6,15.3,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,22.8c-0.2,0-1.7,0.2-1.7-0.2c-0.3-0.6-1.8-2.9-1.5-3.5c0.5-1.2,4.1-2.3,2-4.4c-0.4-0.3-1.8-1.2-1.9-1.7 c-0.1-1,1.1-2.8,1.4-3.7c0.7-1.3,3.7,1.1,4.6-1.5c0.3-0.8-0.5-1.9-0.2-2.7c0.2-0.6,2.8-1.1,3.4-1.4c0.6-0.3,1.3,1,1.6,1.3 c0.9,1,1,1.2,2.4,1.2c0.6,0,1.6-1.6,2-2c0.4-0.4,3.7,0.2,3.7,0.9c0,1.4,0,5.1,2.3,4.6c0.4-0.1,1.9-0.4,2.1,0.2 c0.2,0.4,1.7,3.2,1.2,3.4c-0.4,0.4-2,1.3-2,1.9c-0.3,1.8,0.2,2.1,1.6,3.2c1,0.8,0.6,1.2,0.2,2.4c-0.5,1.5-0.3,1.9-2,1.7 c-2-0.3-3.9-0.2-3.5,2.4c0.1,0.4,0.7,1.9,0,2.1c-0.8,0.3-2.7,1.6-3.5,1.3c-1.8-0.5-1.6-3.7-4.2-1.7c-0.6,0.4-1.1,1.5-1.9,1.5 c-1.4-0.4-3.2-0.6-3.1-2.3C19.6,23.5,18.9,22.3,16.5,22.8z M25.5,10.7c-7.2,0-7.1,11.1,0.2,11.1C33.3,21.7,33.2,10.7,25.5,10.7z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_400",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3,60.6c0.1,1.5-0.8,2.6-2.4,2.6H3.6c-1.8,0-2.6-1-2.6-2.8V17.8c0,0,0-3,3.4-2.9c2.8-0.2,4.9-0.1,8-0.1 c-1.5,1.5-4.1,1.9-4.1,1.9s-3,0-3,2.4c0,2.5,2.8,2.4,2.8,2.4h46.4c0,0,3,0.1,3,3.1v7.5c0,0,0,1-1.1,1c-1.3,0-3.3,0-3.3,0 s-9.8,0.2-9.8,9.7c0,9.9,10.4,10.2,10.4,10.2h3.7V60.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.6,17.6 13.8,17.6 34.7,0 42,8.9 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,48.7c-0.2,0.2-0.5,0.2-0.8,0.2c-1.4,0-2.8,0-4.2,0c-3.2,0-5.8-2.5-5.8-5.7c0-3.3,2.5-5.8,5.8-5.9 c1.3-0.1,2.5,0.1,3.8-0.1c0.6,0,1.7-0.7,1.7-0.7l4.4-2.2v11L58.1,48.7z M52.9,46c1.6,0,2.9-1.2,2.9-2.8c0-1.5-1.4-2.9-2.8-2.9 c-1.6,0-3,1.4-3,3C50.1,44.7,51.4,46,52.9,46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.2,10.3 51,17.6 32.2,17.6 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,32.1c0-4.3,0-6.9,0-11c0-2.4-2-4.4-4.3-4.4c-0.5,0-0.4,0-0.9,0c-1.8,0-2.4-1.9-2.4-1.9s1.8-0.1,3.8,0 C63,14.7,63,21,63,21s0,5.4,0,9.6c0,0.2-0.2,0.6-0.5,0.8C62.2,31.7,61.7,31.8,61.1,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,54c-0.1-1.9,0-1.9,1.9-2.7c0,3.4,0.1,3.3,0,6.6c0,1.1-0.8,1.8-1.9,1.9V54z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_401",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9,37.1c-0.1,0.7,0.6,1.1,1.7,1.6v-3.1C40.3,35.8,39.9,36.5,39.9,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,43.8v3.6c0.9-0.2,1.7-0.8,1.7-1.7S44,44.2,43,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,12.4H36c1.6,0,3-1.3,3-3V5.1c0-1.6-1.3-3-3-3H6.3c-1.6,0-3,1.3-3,3v4.4C3.3,11.1,4.7,12.4,6.3,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,21.2c-2.4,0-4.7,0.4-6.8,1.1c0.3-0.5,0.5-1,0.5-1.6v-4.4c0-1.6-1.3-3-3-3H3c-1.6,0-3,1.3-3,3v4.4             c0,1.6,1.3,3,3,3h29c-0.6,0.3-1.1,0.6-1.7,1h-24c-1.6,0-3,1.3-3,3v4.4c0,1.6,1.3,3,3,3h16c-0.1,0.3-0.2,0.6-0.3,0.9H3             c-1.6,0-3,1.3-3,3v4.4c0,1.6,1.3,3,3,3h18.4c1.9,9.6,10.4,16.9,20.6,16.9c11.6,0,21-9.4,21-21C63,30.6,53.6,21.2,42,21.2z M42,61.2             c-9.1,0-16.7-6.4-18.5-14.9C23.2,45,23,43.6,23,42.2c0-2.2,0.4-4.3,1.1-6.2c0.1-0.3,0.2-0.6,0.3-0.9c1.9-4.6,5.5-8.3,10.1-10.3             c2.3-1,4.8-1.5,7.5-1.5c10.5,0,19,8.5,19,19S52.5,61.2,42,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,25.7c-9.1,0-16.5,7.4-16.5,16.5c0,9.1,7.4,16.5,16.5,16.5c9.1,0,16.5-7.4,16.5-16.5             C58.5,33.1,51.1,25.7,42,25.7z M43.1,51.2V52c0,0.3-0.6,0.8-1,0.8c-0.6,0-1-0.3-1-0.8l0.1-0.7c-3.3-0.1-6-1.8-6-3.5             c0-0.9,0.8-2.2,1.8-2.2c1.1,0,2,1.6,4,1.9v-4.4c-2.5-0.9-5.4-2.1-5.4-5.6c0-3.5,2.6-5.1,5.4-5.5v-0.8c0-0.3,0.5-0.8,1-0.8             s1,0.3,1,0.8v0.7c1.7,0,4.8,0.4,4.8,2.4c0,0.8-0.4,2.2-1.7,2.2c-0.9,0-1.5-0.9-3.1-1v3.9c2.5,0.9,5.4,2.2,5.4,5.8             C48.5,48.6,46.4,50.6,43.1,51.2z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_402",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9,61.3l4.1-19.1L40.5,6.9c3.8-4,7.3-5.9,10.8-5.9c2.7,0,5.4,1.2,7.8,3.7c2.6,2.5,3.9,5.2,3.9,7.9c0,4.3-3.1,8.1-5.9,10.8             L21.9,58.8L2.7,63.2L0.9,61.3z M7.1,55.3c0.6,0,1.1,0.1,1.4,0.4l0.1,0.1c0.8,0.8,0.5,2.3,0.5,2.6l0,0L19.4,56l-0.7-4l-8.3,1.7             l1.3-8.6L8.2,45L6,55.4l0,0C6.1,55.4,6.6,55.3,7.1,55.3z M22.4,53.2l25.4-25.5L36.2,16L10.6,41.5l2.3,0.1l21-20.9l0.1,0             c0.4-0.3,1.2-0.8,1.9-0.8c0.2,0,0.4,0.1,0.6,0.2l0.3,0.1l0.2,0.5c0.1,0.3,0.3,0.7-0.6,2.3l-0.1,0.1L15.1,44.3l-0.4,5l4.6-0.9             l20.8-21l0.1-0.1c0.4-0.3,1.2-0.7,1.8-0.7c0.3,0,0.6,0.1,0.8,0.3c0.7,0.6,0.6,1.6-0.2,2.8l-0.1,0.1L21.9,50.5L22.4,53.2z M50.3,25.4             l1.2-1.2L39.8,12.5l-1.2,1.2L50.3,25.4z M54,21.7l1.6-1.6L43.8,8.3L42.2,10L54,21.7z M58,17.5c1.2-1.7,3.3-5.9-1.2-10.5             c-1.8-1.8-3.7-2.7-5.7-2.7c-2,0-3.8,1-4.7,1.6L58,17.5z"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_500",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,19.9c0.1,3.1,2.6,5.5,5.7,5.5c3.1,0,5.7-2.6,5.7-5.7c0-3.2-2.6-5.7-5.7-5.7L11.5,7c0.5-1.9,2.1-3.3,4-3.7 c1-0.2,2.1-0.3,3.1-0.3c9.2,0,16.6,7.5,16.6,16.6c0,2.3-0.5,4.5-1.4,6.6l26.3,24.1c2.3,2.1,2.5,5.7,0.4,8.1 c-1.1,1.2-2.6,1.9-4.2,1.9c-1.4,0-2.8-0.5-3.9-1.5L26,34.5c-2.3,1.1-4.8,1.7-7.4,1.7C9.5,36.2,2,28.8,2,19.6c0-0.1,0-0.1,0-0.2 c0.1-2,1.3-3.8,3.1-4.6L12.9,19.9z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_501",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,63c-6.1-1.9-4.6-9.5-2.5-13.9c3.9-8.2,13.7-7.9,19.5-13.7c-5.1-6.1-7.2-13.7-6-21.6C17.5,5.7,22.6,3.3,29.6,1 c5.8,0,12,0.6,15.5,5.9c6.4,9.4,1.6,20.3-3.2,28.9c2,0,6.3,3.4,8.1,4.4c3.1,1.6,6.7,3.1,9.1,5.8c2.9,3.3,6,11.1,2.8,15.1 c-3,3.8-10.9,2.1-15,2.1c-8.9,0-17.8,0-26.6,0C15.4,63.1,9.8,63.8,5.3,63z M47.3,55.1c1.4,0,5.9,0.8,7-0.3c1-1-0.4-4.5-1-5.5 c-2.7-4-8.6-4.6-12.5-6.6c-1.8-0.9-6.3-5.6-6.4-7.6c0-1.9,4-6.8,4.9-8.5c4.1-7.8,2.6-19.4-8.6-17.7c-12.3,1.8-5.9,17.3-2.4,23.8 c0.5,0.9,1.8,2.4,1.7,3.2c-2,1.6-3.3,3.9-5.2,5.7c-3.6,3.3-9,3.9-12.8,6.9c-1.6,1.2-4.1,6.6-0.6,6.6c1.1,0.4,3.4,0,4.6,0 C26.4,54.9,36.8,54.8,47.3,55.1z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_502",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,54.3c1.5-3,3-6,4.4-9c1.7-3.5,3.4-6.9,5-10.4c0.3-0.7,0.8-1,1.5-1             c2.5,0,4.9,0,7.4,0c0.5,0,1.1,0.3,1.4,0.7c1,1,1.9,2.1,3,3.3c-0.8,0-1.4,0-1.9,0c-2.4,0-4.9,0-7.3,0c-0.7,0-1.2,0.2-1.5,0.9             c-2,4.1-3.9,8.1-5.9,12.2c-0.1,0.1-0.1,0.3-0.2,0.5c16.7,0,33.3,0,50,0c-0.1-0.3-0.2-0.5-0.3-0.7c-1.9-3.9-3.8-7.8-5.7-11.8             c-0.4-0.8-0.9-1.1-1.7-1.1c-3,0-5.9,0-9.2,0c1.3-1.4,2.4-2.6,3.6-3.8c0.2-0.2,0.7-0.2,1-0.2c2.4,0,4.8,0,7.2,0c0.8,0,1.3,0.3,1.7,1             c3.1,6.3,6.1,12.6,9.2,18.9c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.5,0,0.7c-0.5,0.2-1,0.5-1.5,0.5c-9.6,0-19.2,0-28.7,0             c-10.1,0-20.3,0-30.4,0c-0.4,0-0.9-0.3-1.3-0.5C1,54.8,1,54.5,1,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1,7c8.1,0,14.6,7.2,13.9,15.3c-0.4,4.3-2.5,7.7-5.3,10.8             c-1.9,2.1-3.7,4.3-5.4,6.5c-1,1.3-1.6,2.9-2.4,4.3c-0.2,0.3-0.6,0.7-1,0.7c-0.3,0-0.8-0.3-1-0.6c-1.7-4.3-4.8-7.6-7.8-11             c-1.7-1.8-3.2-3.7-4.2-6.1C15.5,18.4,20.9,8.4,30,7.2C30.7,7.1,31.4,7.1,32.1,7z M32,28.5c4.1,0,7.4-3.3,7.4-7.4             c0-4.1-3.3-7.4-7.5-7.4c-4,0-7.4,3.5-7.3,7.4C24.6,25.2,27.9,28.5,32,28.5z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_503",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9,1c10,0,20,0,30,0C47,1,47,1.1,47.1,1.1c0.9,0.1,1.7,0.3,2.4,0.8             c2.6,1.4,3.9,3.6,3.9,6.6c0,3.7,0,7.5,0,11.2c0,0.1,0,0.3,0,0.5c0.2,0,0.4,0,0.6,0c1.1,0,2.2,0,3.3,0.2c3.1,0.5,5.7,3.3,5.8,6.7             c0.1,4.9,0,9.7,0,14.6c0,1.1-0.2,2.1-0.7,3.1c-1.1,2.2-2.8,3.6-5.2,3.9c-1.1,0.2-2.2,0.1-3.2,0.1c-0.2,0-0.3,0-0.5,0             c0,0.2,0,0.3,0,0.4c0,2.2,0,4.4,0,6.7c0,2-0.7,3.7-2.1,5.1C49.8,62.3,48.1,63,46,63c-9.5,0-19,0-28.5,0c-1.6,0-3.1-0.5-4.4-1.5             c-1.8-1.5-2.7-3.4-2.8-5.7c0-2.2,0-4.4,0-6.6c0-0.1,0-0.3,0-0.4c-0.2,0-0.3,0-0.4,0c-0.9,0-1.8,0-2.7-0.1c-3-0.4-4.9-2.1-6-4.9             c-0.2-0.5-0.2-1-0.4-1.5C1,37,1,31.7,1,26.5c0,0,0.1-0.1,0.1-0.1C1.4,23.9,2.7,22,5,20.8c1-0.5,2-0.8,3.1-0.7c0.8,0,1.6,0,2.4,0             c0-0.2,0-0.3,0-0.4c0-3.8,0-7.6,0-11.4c0-3.2,2-6,5.1-6.9C16,1.2,16.4,1.1,16.9,1z M15.2,36.8c0,0.1,0,0.2,0,0.3             c0,6.3,0,12.5,0,18.8c0,1.3,1,2.3,2.3,2.3c1.7,0,3.4,0,5.2,0c4.8,0,9.6,0,14.4,0c3,0,6,0,9,0c1.5,0,2.4-1,2.4-2.5             c0-0.7,0-1.4,0-2.1c0-5.1,0-10.2,0-15.4c0-0.5,0-1,0-1.5C37.5,36.8,26.4,36.8,15.2,36.8z M48.6,20.1c0-0.2,0-0.3,0-0.4             c0-3.8,0-7.5,0-11.3c0-1.5-1.1-2.6-2.6-2.6c-9.4,0-18.8,0-28.2,0c-1.6,0-2.6,1-2.6,2.5c0,3.8,0,7.6,0,11.4c0,0.1,0,0.2,0,0.3             C26.4,20.1,37.5,20.1,48.6,20.1z M52.2,24.8c-2,0-3.6,1.6-3.6,3.6c0,2,1.7,3.5,3.7,3.5c1.9,0,3.5-1.6,3.5-3.6             C55.8,26.4,54.2,24.8,52.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,41.5c0,1.6,0,3.1,0,4.7c-7.9,0-15.8,0-23.8,0c0-1.6,0-3.1,0-4.7C28,41.5,35.9,41.5,43.9,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,53.4c0-1.6,0-3.1,0-4.7c5.5,0,11.1,0,16.7,0c0,1.6,0,3.1,0,4.7C31.2,53.4,25.7,53.4,20.1,53.4z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_504",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,6.3C7.6,6.6,7.3,6.9,7.5,7.6l4,6.7c0.5,0.7,1.1,1.2,1.8,1.7 c0.5,0.4,1.3,0.8,1.8,0.7c1.3-0.3,1.8,0.6,2.5,1.3c4.4,5,8.8,9.9,13.2,14.9c0.2,0.2,0.3,0.4,0.2,0.6c-0.1,0.6-0.3,1.2-0.4,1.8 c-0.3,2.5,0.7,4.6,2.4,6.4c5,5.6,10,11.2,15,16.8c1.6,1.8,3.6,2.2,5.8,1.6c2.2-0.6,3.7-2,4.1-4.2c0.5-2.5,0.2-4.8-1.7-6.9 c-5-5.5-9.9-11.2-14.9-16.8c-1.6-1.8-3.4-2.7-5.9-2.2c-0.8,0.2-1.8,0.3-2.5-0.9L19.4,14.1c-0.2,0.2,0.1-0.1,0,0 c0.7-2.4-0.3-4.1-2-5.7c-1.7-1.6-3.6-3-5.5-4.5C11.4,3.5,11,3.5,10.5,4L7.8,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3,50.6C0.8,52,0.9,53.1,2,54.3c1.9,2,3.6,4.1,5.5,6.1 c0.3,0.3,0.9,0.6,1.3,0.5c3.1-0.6,6.2-1.3,9.3-1.9c0.6-0.1,0.9-0.4,1.1-1c0.9-2.9,1.9-5.9,2.9-8.8c0.2-0.5,0.5-1,0.9-1.4 c2-1.8,3-2.6,5.1-4.4c0.9-0.7,1-1.5,0.5-2.7c-0.7-1.5-1.5-2-1.3-3.6c0.3-1.9,0.7-3.3,0-4c-0.9-1-0.8-0.9-1.4-1.7 c-0.4-0.5-0.9-0.5-1.4-0.1l-9,7.9c-0.2,0.2-0.5,0.3-0.8,0.3c-3,0.6-6,1.1-8.9,1.6c-0.9,0.2-1.5,0.4-1.7,1.4L1.3,50.6z M7.4,51.4 l1.2-4.2l4.4-1.1l3.1,3.3l-1.3,4.1l-4.7,1L7.4,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9,22.9c-1,0.9-1.1,1.8-0.2,2.8c0.7,0.7,0.2,0.2,0.8,0.9 c0.3,0.4,1.1,0.6,1.6,0.4c2.3-0.8,4.8,1,6.6,2.4c0.6,0.5,1,0.2,1.4-0.2c2.2-2,3.9-3.4,6.1-5.4c0.4-0.4,0.6-0.3,1.2-0.4 c3-0.6,6.1-1.1,9.1-1.7c0.3-0.1,0.9-0.3,0.9-0.5c0.6-1.7,1.1-3.5,1.6-5.2c0.2-0.8-0.3-1-1-1c-0.5,0-1.5,0.3-1.5,0.3l-7.3,1.6 L50,13.7l1.7-4.2c0,0,5.5-1.2,8.2-1.7c1.2-0.2,1.6-1.5,0.8-2.4c-0.9-1-1.8-2-2.7-3C57.7,2.1,57.3,2,57,2l-9.3,1.9 C47,4,46.7,4.4,46.5,5l-2.8,8c-0.2,0.9-0.5,1.8-1.3,2.5L33.9,22.9z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_505",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2.4C6,4,6.2,4.6,6.8,5.1c0.6,0.5,1.1,0.7,2.6,0.7h1.4v1.5c0,1.2,0,1.5,0.2,1.9c0.5,0.9,1.4,1.4,2.4,1.4h0.5v0.7 c0,2,0.5,5.3,1.1,7.4c1.2,4.1,3,6.9,6.3,9.7c1.9,1.6,2.8,2.5,2.9,3c0.2,0.6,0,1.3-0.5,1.9c-0.2,0.3-1.1,1.1-2,1.9 c-2.7,2.3-4.2,4.2-5.4,6.6c-1.4,2.9-2.3,6.4-2.5,10.2l-0.1,1.6h-0.5c-1.1,0-1.9,0.5-2.3,1.3c-0.2,0.4-0.2,0.7-0.2,2v1.5l-1.6,0.1 c-1.6,0.1-1.6,0.1-2.1,0.4c-0.8,0.6-1,1-1,2.8L6,63h26.2h26.2v-1.4c0-1.6-0.2-2.1-0.8-2.7c-0.6-0.5-1.1-0.7-2.6-0.7h-1.4v-1.4 c0-1.1-0.1-1.5-0.2-1.9c-0.4-0.9-1.3-1.5-2.3-1.5h-0.6L50.5,52c-0.3-5.1-1.6-9.3-3.9-12.5c-1-1.5-2-2.5-4.1-4.3 c-2.2-1.9-2.5-2.2-2.5-3.1c-0.1-0.9,0.2-1.1,2.2-2.8c2-1.7,2.9-2.5,3.8-3.8c2.7-3.4,4.2-7.9,4.5-13.6l0.1-1.4H51 c0.7,0,1.3-0.2,1.8-0.6c0.7-0.6,0.9-1.1,0.9-2.8V5.8H55c1.6,0,2.1-0.1,2.7-0.7c0.6-0.6,0.8-1.1,0.8-2.7V1H32.2H6V2.4z M46.6,11.7 c-0.4,5.4-1.6,8.9-4.1,11.9c-0.4,0.5-1.5,1.5-2.5,2.4c-2.6,2.3-3.1,2.9-3.6,4.2c-0.3,0.9-0.3,2.5,0,3.4c0.4,1.3,1,2.1,3.5,4.3 c2.6,2.3,3.6,3.4,4.6,5.5c1.3,2.5,1.9,5,2.2,9l0.1,1h-2.5h-2.5v-0.5c0-1.6-0.5-3.8-1.4-5.5c-0.7-1.5-1.7-2.8-3.4-4.8 c-1.9-2.2-2.7-3.2-3.1-4.2c-0.7-1.4-0.8-2.8-0.5-4.8c0.5-2.7,1.3-4.4,3.6-6.9c1.9-2.1,2.3-2.8,2.5-3.8l0.1-0.5h-7.1h-7.1l0.1,0.4 c0.1,0.8,0.5,1.4,1.8,2.8c2.1,2.4,3,3.8,3.7,5.8c0.4,1.4,0.6,2.5,0.6,4.1c0,2.4-0.5,3.4-3.6,6.9c-2,2.2-2.8,3.4-3.6,5 c-0.8,1.6-1.3,3.2-1.4,4.9l-0.1,1.1h-2.5h-2.5l0.1-1.3c0.3-4.2,1.2-7.5,2.8-10c0.8-1.3,1.9-2.5,3.8-4.1c2.7-2.4,3.3-3.1,3.7-4.6 c0.5-1.9,0-3.9-1.3-5.4c-0.3-0.3-1.3-1.2-2.2-2c-0.9-0.8-2-1.8-2.4-2.2c-2.6-2.8-4.1-6.8-4.4-12l-0.1-1.3h14.5h14.5L46.6,11.7z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_506",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#retur",
    width: 64,
    height: 64,
    x: -4
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_600",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8,38.3c0,0,0-2.3,1.7-3.6c1.8-1.3,5.9-2.8,5.9-2.8c0.3,1.9,1.2,5.4,2.7,7.7c0.1-0.5,0.3-3.1,0.4-4c0-0.6-0.5-1.2-0.7-1.6 c-0.2-0.5,0-0.8,0.5-0.8c0.7-0.1,1.4-0.1,2.2,0c0.5,0,0.6,0.4,0.4,0.8c-1.2,1.5-1.4,3.3-1.4,4.1v12.4c0,0-5.4,0.1-9.2-0.4 c-2.3-0.3-2.5-2.4-2.5-2.5V38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,47.5c0,1.9-1.5,2.4-2.3,2.6c-2.7,0.8-9.2,1.1-9.2,1.1l0-11.3c0.7-0.2,2.9-2.2,4.1-5c0.1-0.2,0.1-0.3,0.6,0.1 c0.6,0.5,1,1.6,1,1.6c0-1.8-0.8-3.3-1.1-3.9c6.5,1.8,7,3.5,6.9,5.8C63,39,63,47,63,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,30.2c0.7,3.9,1.9,7.2,3.9,11.1l0,0l0.6-6.8c0-0.3-0.2-0.8-0.2-0.8l-0.8-1.5c-0.1-0.5,0.2-1,0.7-1.1c1.2,0,2.4,0,3.7,0 c0.5,0,0.8,0.7,0.6,1.1c-0.3,0.6-0.8,1.6-0.8,1.6s-0.1,0.6-0.1,0.7l0.6,6.8c1.8-3.5,3-7.1,3.8-11.1l8.5,3.4c1.7,0.8,2.7,2.2,2.9,4 c0.1,1.4,0.2,14.1,0,15.5c0,0,0,2-3.5,2.7c-12.2,2.5-13.7,2.5-27.8,0c-3.5-0.6-3.5-3.5-3.5-3.5C14.4,51,14.4,38.4,14.7,37 c0.3-1.7,1.3-2.9,2.9-3.6L26,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,16.3c0-1.7,1.4-1,1.4-1C23.5,5.1,26.8,5.9,27,5.4c0.1-0.5-0.2-2,5-2c10.5,0,7.8,11.8,7.8,11.8s1.3-0.7,1.3,0.6 c0,4.4-1.5,4.5-1.5,4.5c-0.1,0-0.2,0.3-0.3,0.4c-2.9,6.4-4.5,7.3-7.4,7.3c-2.9,0-4.1-1.2-6.8-7.3c-0.1-0.3-0.2-0.4-0.5-0.4 C24.5,20.3,23.2,19.6,23.2,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,30c0,1.9,0.6,2,0.6,2.1c-0.5,2.2-2.6,4.2-2.7,4.3c-0.2-1.5-1-3.2-2.9-4.5c0,0,0.7-1.2,0.6-1.9c0,0-3.6-0.6-5-1.5 c-0.4-0.3-0.1-0.7-0.1-0.7c1.2-1-0.4-2.1-0.4-6.1c0-8.3,5.4-8.3,5.4-8.3c0.7-0.5,1.4-0.7,2.3-0.7c6.3,0,8.3,7.6,7,11.5 c-0.8,2.5-0.6,2.8,0.1,3.5c0.2,0.3,0.2,0.5-0.1,0.8C57.6,29.2,53.6,30,53.6,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,21.8c0-1.3,1-0.8,1-0.8c-0.8-7.4,1.7-6.9,1.7-7.2c0.1-0.3-0.1-1.5,3.6-1.5c7.7,0,5.7,8.6,5.7,8.6s1-0.5,1,0.4 c0,3.2-1.1,3.3-1.1,3.3c-0.1,0-0.2,0.2-0.2,0.3c-2.1,4.7-3.3,5.3-5.4,5.3c-2.1,0-3-0.9-5-5.3c-0.1-0.2-0.1-0.3-0.3-0.3 C7,24.7,6,24.2,6,21.8z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_601",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2,20.3l0.4-5.9c0,0-1-0.8-0.9-1.5c0-0.7,2.9-0.7,3,0c0,0.4-0.7,1.4-0.7,1.4l0.5,6.1l2.6-7.6c0,0,8.6,0,8.5,6.1l0.1,17.6 c0,2.1-1.8,3.4-3.5,2.5c-1-0.5-1.3-1.5-1.3-2.5c0,0,0-15.8,0-17.2c0-0.5-0.3-1.1-0.6-1.1c-0.3,0-0.5,0.7-0.5,1.1V60 c0,1.8-1.2,3.1-2.8,3.1c-1.7,0-2.8-1.2-2.9-3.1V38c0,0,0.2-1.4-0.6-1.5c-1-0.1-0.8,1.4-0.8,1.4v21.8c0,1.7-0.7,2.7-2,3.2 c-1.7,0.6-3.4-0.5-3.7-2.2l-0.1-41.2c0-0.5-0.1-1.1-0.5-1.1s-0.5,0.5-0.5,1l-0.1,17.3c0,1.5-1,2.6-2.4,2.6c-1.3,0-2.4-1-2.4-2.5 l0.2-18.3c0.1-3,3.8-5.7,8.2-5.7L21.2,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,6.1c0-2.8,2.2-5.1,5-5.1c2.7,0,5,2.3,5,5s-2.3,5.1-5,5.1C19.6,11.1,17.4,8.8,17.4,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7,15.3l0.3-4.1c0,0-0.7-0.5-0.6-1c0-0.5,2-0.5,2.1,0c0,0.3-0.5,1-0.5,1l0.4,4.2l1.8-5.2c0,0,5.9,0,5.8,4.2L58,26.4 c0,1.4-1.2,2.3-2.4,1.7c-0.7-0.3-0.9-1-0.9-1.7c0,0,0-10.9,0-11.8c0-0.3-0.2-0.8-0.4-0.8c-0.2,0-0.3,0.5-0.3,0.8v28 c0,1.2-0.8,2.1-1.9,2.1c-1.2,0-1.9-0.8-2-2.1V27.5c0,0,0.1-1-0.4-1c-0.7-0.1-0.6,1-0.6,1v15c0,1.2-0.5,1.9-1.4,2.2 c-1.2,0.4-2.3-0.3-2.5-1.5L45,14.8c0-0.3-0.1-0.8-0.3-0.8c-0.3,0-0.3,0.3-0.3,0.7l-0.1,11.9c0,1-0.7,1.8-1.7,1.8 c-0.9,0-1.7-0.7-1.7-1.7L41.1,14c0.1-2.1,2.6-3.9,5.6-3.9L48.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,5.5c0-1.9,1.5-3.5,3.4-3.5C51.4,2,53,3.6,53,5.4C53,7.3,51.4,9,49.5,9C47.6,9,46.1,7.4,46.1,5.5z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_602",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,18.3l0-3.4c0-2.8-1.1-3.9-3.9-3.9l-8.2,0c-2.6,0-5.2,0-7.8,0             c-0.6,0-0.7,0-0.8-0.6C41,5.8,37.1,3,32,3c-5.1,0-8.9,2.8-10.3,7.4C21.5,11,21.4,11,20.8,11c0,0,0,0,0,0c-2.7,0-5.4,0-8.1,0             c-2.1,0-8.1,0-8.1,0C2.2,11,1,12.2,1,14.6l0,2.6c0,4.1,0,8.3,0,12.5c0,1,0.6,2.2,1.4,2.8C2.9,32.8,3,33,3,33.6c0,5.3,0,10.6,0,15.9             l0,3.5C3,55.9,4.1,57,6.9,57l38.6,0l11.7,0c2.8,0,3.9-1.1,3.9-3.9l0-3.9c0-5.1,0-10.2,0-15.3c0-0.8,0.1-1.2,0.6-1.6             c0.9-0.6,1.3-2,1.3-3C63,25.7,63,21.9,63,18.3z M31.5,8c3.2-0.2,5.2,1.2,6,4c-3.7,0-7.3,0-11,0C27,9.6,28.8,8.1,31.5,8z M54.9,50.9             H9.1V36c6.8,2.9,13.2,4.5,19.7,4.8c0.1,0,0.2,0,0.2,0c0,0,0,0.1,0,0.1c0,0.4,0,0.9,0,1.4c0.2,1.6,1.3,2.6,2.9,2.6             c1.6,0,2.7-1,2.9-2.6c0.1-0.6,0.2-1.2,0.2-1.4c0.2-0.1,0.8-0.2,1.5-0.2c6.3-0.6,12.4-2.2,18.3-4.8V50.9z M57,28.2             c0,0-0.1,0.2-0.1,0.2c-7.3,4-14.5,6.1-22,6.6c0-0.1,0-0.2,0-0.3c0-1.1-0.1-3.4-2.9-3.4l-0.2,0c-2.7,0.1-2.8,2.3-2.8,3.6             c0,0.1,0,0.1,0,0.2c-0.4,0-0.8-0.1-1.1-0.1c-1.6-0.2-3.1-0.3-4.6-0.6c-5.3-1-10.6-2.8-15.6-5.5C7,28.4,7,28.2,7,27.6             c0.1-2.8,0-5.4,0-8.3l0-2.2h50l0,1.6C57,21.9,57,25,57,28.2z"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_603",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,1C14.9,1,1,14.9,1,32c0,17.1,13.9,31,31,31c17.1,0,31-13.9,31-31C63,14.9,49.1,1,32,1z M32,54.9c-12.7,0-23-10.3-23-23 c0-12.7,10.3-23,23-23c12.7,0,23,10.3,23,23C55,44.6,44.7,54.9,32,54.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 32,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 50,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,35.7l-6-3.5c0-0.1,0-0.1,0-0.2c0-2.2-1.2-4.2-3-5.2V14c0-1.6-1.3-3-3-3c-1.7,0-3,1.3-3,3v12.8c-1.8,1-3,3-3,5.2 c0,3.3,2.7,6,6,6c1,0,2-0.3,2.8-0.7l6.2,3.6c1.4,0.8,3.3,0.3,4.1-1.1C45.9,38.3,45.4,36.5,44,35.7z M32,35c-1.7,0-3-1.3-3-3 c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3C35,33.7,33.7,35,32,35z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_604",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4,35.8c0.9,5.2,2.5,9.6,5.2,14.8l0,0l0.8-9.1c0-0.4-0.3-1.1-0.3-1.1l-1.1-2C29,37.8,29.4,37.1,30,37c1.6,0,3.2,0,4.9,0 c0.7,0,1.1,0.9,0.8,1.5c-0.4,0.8-1.1,2.1-1.1,2.1s-0.1,0.8-0.1,0.9l0.8,9.1c2.4-4.7,4-9.5,5.1-14.8l11.4,4.5 c2.3,1.1,3.6,2.9,3.9,5.3c0.1,1.9,0.3,9.4,0,11.3c0,0,0,2.7-4.7,3.6c-16.3,3.3-18.3,3.3-37.1,0c-4.7-0.8-4.7-4.7-4.7-4.7 c-0.3-1.7-0.3-9.1,0.1-11c0.4-2.3,1.7-3.9,3.9-4.8L24.4,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,18.2c0-2.3,1.9-1.3,1.9-1.3C21.1,3.3,25.5,4.3,25.8,3.7C25.9,3,25.5,1,32.4,1c14,0,10.4,15.8,10.4,15.8 s1.7-0.9,1.7,0.8c0,5.9-2,6-2,6c-0.1,0-0.3,0.4-0.4,0.5c-3.9,8.5-6,9.7-9.9,9.7c-3.9,0-5.5-1.6-9.1-9.7c-0.1-0.4-0.3-0.5-0.7-0.5 C22.4,23.6,20.7,22.6,20.7,18.2z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_951",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,1H8C4.1,1,1,4.2,1,8v48c0,3.9,3.2,7,9,7h39.3c-0.1,0,2.6-0.7,3.9-2l7.7-7.6c1.3-1.3,2.1-3.1,2.1-5V8C63,4.1,59.9,1,56,1 z M38,54c0,1.7-1.4,3-3,3s-3-1.3-3-3v-3c0-1.6,1.3-3,3-3c1.7,0,3,1.3,3,3V54z M57,48.5c0,0.2-0.1,0.5-0.3,0.7L49,56.8 C48.8,57,47.6,57,47.3,57l0,0H46v-8c0-3.9-3.2-7-7-7H21c-3.9,0-7,3.2-7,7v8H8c-0.5,0-1-0.4-1-1V8c0-0.5,0.5-1,1-1h3v16 c0,3.9,3.2,7,7,7h28c3.9,0,7-3.2,7-7V7h3c0.5,0,1,0.4,1,1V48.5z"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_952",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2,1h-17c-2.8,0-4.5,1.7-4.5,4.5V10h-12C10.2,10,8,12.2,8,15.7v41.6c0,3.4,2.3,5.7,5.7,5.7H44 c3.6,0,5.7-2.1,5.7-5.7v-14h4.7c2.9,0,4.6-1.7,4.6-4.5v-26L47.2,1z M44.5,57.4c0,0.2,0,0.3,0,0.4c-0.1,0-0.2,0-0.4,0H13.7 c-0.2,0-0.3,0-0.4,0l0,0c0-0.1,0-0.2,0-0.4V15.7c0-0.2,0-0.3,0-0.4c0.1,0,0.2,0,0.4,0h18.5v13.1h12.3V57.4z M54.8,38.8 c0,0.1,0,0.3,0,0.3c-0.1,0-0.2,0-0.3,0h-4.7V24.8L34.9,10.1h-5.1V5.5c0-0.2,0-0.3,0-0.3c0.1,0,0.2,0,0.3,0H45v10.5h9.8V38.8z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_953",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6,27.6c-0.5-3.5-9.2-1.1-8.6-5.9c0.3-2.2,1.4-4,2.7-5.8 c1.6-2.1-2.1-5.1-3.5-6.4c-2-1.9-3.4-3.5-6-1.7c-1.7,1.2-4.8,3.3-6.8,1.5c-1.6-1.5-2.1-4.2-2.4-6.3c-0.3-2.3-4.1-1.9-5.8-2 c-1.6,0-5.5-0.4-6.3,1.4c-1,2.2-0.5,4.9-2.5,6.8c-1.8,1.7-4.5,0.2-6.2-0.9c-0.9-0.6-1.9-1.8-3.1-1.5c-1.3,0.3-2.6,1.8-3.5,2.7 c-1.2,1.1-4.4,3.7-4,5.6c0.6,2.5,3.5,4.1,3.1,7.1c-0.3,2.5-4,3.3-6,3.6C1,26.3,1.3,28,1,30.7c0,0.9,0,1.8,0,2.8 c0.2,1.7-0.2,4.5,2,4.8c2.1,0.3,5.8,0.8,6.7,3.1c0.9,2.4-1.4,5.2-2.7,7c-1.5,2,2.3,5.1,3.6,6.3c0.9,0.8,1.8,1.6,2.8,2.4 c1.3,1,2.5-0.3,3.6-1c1.7-1.1,4.5-2.8,6.4-1.1c1.9,1.7,1.8,4.3,2.4,6.5c0.6,2,3.1,1.2,4.6,1.7c0.9,0,1.8,0,2.8,0 c2.3-0.6,4.4,0.3,4.9-2.6c0.3-2,0.9-5.4,3.2-6.1c2.3-0.8,5.1,1.4,6.8,2.7c2.2,1.6,5.6-2.8,6.9-4.2c0.7-0.8,1.9-1.8,2.1-2.9 c0.3-1.2-1.1-2.4-1.6-3.4c-1.1-1.7-2.6-4.8-0.4-6.3c1.1-0.8,2.5-1.3,3.8-1.6c1.1-0.3,2.9-0.1,3.5-1.3C63.6,34.6,63,30.3,62.6,27.6 C62.5,26.7,62.9,29.4,62.6,27.6z M32,45.4c-7,0-13-5.7-13.3-12.8c-0.3-7.3,5.5-13.6,12.8-14c7.2-0.4,13.6,5.4,13.9,12.6 C45.7,38.8,39.5,45.5,32,45.4C24.5,45.4,39.3,45.5,32,45.4z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_954",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6,63.4c-1.6,0-3.3,0-4.9,0c-1.5-0.3-3.1-0.5-4.6-0.8 C9.3,58.9-1.1,43.6,1.4,27.4C3.2,15,12.8,4.7,25.2,1.8c1.5-0.4,3.1-0.6,4.6-0.8c1.6,0,3.2,0,4.9,0c0.2,0,0.4,0.1,0.6,0.2 c5.2,0.5,9.9,2.3,14.2,5.2c1.7,1.2,3.2,2.5,4.8,3.7c1.7-1.2,3.4-2.5,5.2-3.7c0.5-0.3,1.2-0.5,1.7-0.4c0.7,0.2,0.8,0.9,0.8,1.6 c0,7.5,0.1,15.1,0.1,22.6c0,1.7-0.7,2.1-2.3,1.6c-3.5-1.2-7-2.4-10.4-3.5c-3.7-1.3-7.4-2.5-11-3.8c-0.5-0.2-1-0.7-1.2-1.2 c-0.3-0.7,0.3-1.2,0.9-1.5c0.7-0.5,1.4-1,2.2-1.5c1.1-0.8,2.3-1.7,3.5-2.5c-0.1-0.2-0.2-0.3-0.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.5 c-4.6-3.1-9.6-4-15-2.6c-11.4,3-17.2,15.6-11.8,26.2c3.9,7.7,13.3,11.8,21.6,9.3c4.1-1.2,7.5-3.6,9.9-7.1c0.9-1.2,1.6-1.4,2.9-0.5 c2.4,1.7,4.9,3.4,7.3,5.1c0.9,0.7,1.1,1.5,0.5,2.4c-4.5,6.5-10.6,10.8-18.3,12.7C38,62.9,36.3,63.1,34.6,63.4z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_955",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,14.2v2.2c0,1.1-0.2,2.2,0.8,2.9l20.7,18.6c1.3,1.1,2.1,2.9,2.1,4.5V64l15.2-6.5V42.3c0-1.6,0.8-3.4,1.9-4.5l20.5-18.4 c0.8-0.8,0.8-1.8,0.8-2.9v-2.4c-5.4,3.5-18.2,4.4-31.2,4.4C18.9,18.5,6.1,17.9,1,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,2C12.9,2.2,1,4.5,1,7.5c0,2.9,11.9,5.2,31,5.2c19.1,0,31-2.2,31-5.2C63.1,4.5,51.3,2.2,32,2L32,2z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_956",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6,31.3C59.2,37.2,55,42,49,44.3c-3.3,1.3-7,1.9-10.6,1.6 c-4-0.4-7.3-2.1-10.7-3.9c-3,3.2-6.1,6.3-9.2,9.4c-3.2,3.2-6.3,6.6-9.7,9.6c-1.4,1.2-2.9,2.6-4.8,1.9c-1.5-0.5-2.9-2-2.9-3.6 c0-1.8,0.9-2.8,2.1-4c1.6-1.6,3.2-3.2,4.8-4.8c3.2-3.3,6.5-6.5,9.7-9.8c1.5-1.5,2.9-2.9,4.4-4.4c-1.1-1.8-2.1-3.7-2.8-5.7 c-2.1-6.3-1.1-13.6,2.5-19.2c3.6-5.6,9.5-9.1,16-10c6.8-0.9,13.7,1.5,18.7,6.2C62.5,13.4,64.8,23.3,61.6,31.3 C58.4,39.5,62.3,29.4,61.6,31.3z M55.2,23.4c0-6.4-4.4-12.2-10.5-14c-6.1-1.8-12.8,0.7-16.3,6c-3.5,5.3-3.2,12.5,0.9,17.4 c3.4,4.2,8.9,6,14.2,5.1C50.3,36.6,55.2,30.3,55.2,23.4C55.3,15.4,55.2,33,55.2,23.4z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "b_958",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8,34c0-3.5,0-7.1,0-10.7c0-1.4,0.4-2.5,1.4-3.5C9.4,14.6,14.5,9.4,19.8,4.2c0.7-0.7,1.9-1.1,2.8-1.1 C30,3,37.4,3,44.9,3.1c1,0,2.3,0.5,3,1.3C53.1,9.5,58.4,14.7,63.5,20c0.7,0.8,1.2,2,1.2,3.1c0.1,7.3,0.1,14.6,0.1,21.9 c0,1.3-0.5,2.4-1.4,3.3C58.3,53.4,53.1,58.5,48,63.6c-1,1-2.1,1.5-3.6,1.5c-7.1,0-14.2,0-21.4,0c-1.5,0-2.6-0.5-3.7-1.6 c-5-5.1-10.1-10.2-15.2-15.2c-1-1-1.4-2.1-1.4-3.5C2.8,41.2,2.8,37.6,2.8,34z M4.4,34c0,3.5-0.1,6.9,0.1,10.4 c0.1,1.1,0.6,2.4,1.3,3.2c4.8,5,9.6,9.8,14.6,14.6c0.8,0.7,2.1,1.3,3.2,1.3c6.8,0.1,13.7,0.1,20.5,0c1.1,0,2.4-0.6,3.2-1.3 c4.9-4.8,9.7-9.7,14.6-14.6c0.9-0.9,1.3-1.9,1.3-3.2c0-6.9,0-13.9-0.1-20.8c0-1-0.4-2.1-1.1-2.8C57,15.7,52,10.7,47,5.8 c-0.7-0.7-1.9-1.1-2.8-1.2c-6.9-0.1-13.9-0.1-20.8,0c-1,0-2.2,0.5-2.9,1.2c-5,4.8-9.8,9.8-14.7,14.7c-1,1-1.4,2-1.3,3.4 C4.5,27.2,4.4,30.6,4.4,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1,29.8c-0.7,0-1.1,0-1.3,0.1v4.2c0.3,0.1,0.6,0.1,1.1,0.1c1.7,0,2.8-0.9,2.8-2.3C54.6,30.6,53.7,29.8,52.1,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7,29.8c-2.2,0-3.4,2.1-3.4,4.8c0,2.7,1.3,4.7,3.4,4.7h0c2.2,0,3.4-2,3.4-4.8C42.1,32,40.9,29.8,38.7,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,24.5c-0.1-1-0.5-2.2-1.2-2.9c-4.3-4.4-8.7-8.7-13-13.1c-1-1-2.1-1.4-3.4-1.4c-6,0-12,0-18,0C23,7,22,7.6,20.9,8.7 c-4.1,4.2-8.3,8.4-12.5,12.6c-1,1-1.5,2.1-1.5,3.5c0,6.1,0,12.1,0,18.1c0,1.4,0.5,2.6,1.5,3.6c4.3,4.3,8.6,8.5,12.8,12.8 c1,1,2.1,1.5,3.5,1.5c6.1-0.1,12.1,0,18.2-0.1c1.1,0,2.4-0.6,3.2-1.3c4.4-4.2,8.7-8.7,13.1-13c0.9-0.9,1.3-1.9,1.3-3.2 c0-3,0-6.1,0-9.1C60.5,31,60.5,27.8,60.3,24.5z M13.8,41.9c-1.6,0-3.2-0.4-4-0.9l0.7-2.6c0.8,0.4,2.2,0.9,3.5,0.9 c1.5,0,2.2-0.6,2.2-1.6c0-0.9-0.7-1.4-2.4-2c-2.4-0.8-3.9-2.1-3.9-4.2c0-2.4,2-4.2,5.4-4.2c1.6,0,2.8,0.3,3.6,0.7l-0.7,2.6 c-0.5-0.3-1.6-0.7-2.9-0.7c-1.4,0-2.1,0.7-2.1,1.4c0,0.9,0.8,1.3,2.6,2c2.5,0.9,3.7,2.2,3.7,4.2C19.5,39.9,17.6,41.9,13.8,41.9z  M31.4,30.2h-3.9v11.5h-3.2V30.2h-3.8v-2.7h10.9V30.2z M38.6,41.9L38.6,41.9c-4.2,0-6.7-3.2-6.7-7.2c0-4.2,2.7-7.4,6.9-7.4 c4.3,0,6.7,3.3,6.7,7.2C45.5,39.1,42.7,41.9,38.6,41.9z M56.5,35.2c-1.1,1-2.7,1.5-4.6,1.5c-0.4,0-0.8,0-1.1-0.1v5.1h-3.2v-14 c1-0.2,2.4-0.3,4.3-0.3c2,0,3.4,0.4,4.3,1.2c0.9,0.7,1.5,1.9,1.5,3.3C57.8,33.2,57.3,34.4,56.5,35.2z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "_qr",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "6,6 22,6 22,2 2,2 2,22 6,22  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,22V10H10v12H22z M14,14h4v4h-4V14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,2 41,6 58,6 58,22 62,22 62,2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,22V10H42v12H54z M46,14h4v4h-4V14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6,42 2,42 2,62 22,62 22,58 6,58  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42h-4v12h12V42H14z M18,50h-4v-4h4V50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58,58 41,58 41,62 62,62 62,42 58,42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34,38 50,38 50,46 54,46 54,34 34,34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54,54 54,50 30,50 30,34 10,34 10,38 26,38 26,54  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,30 38,30 38,10 34,10 34,26 10,26  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 4,
    height: 4
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "_loc",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,1C18.2,1,7,12.2,7,26s25,38,25,38s25-24.2,25-38S45.8,1,32,1z M32,41.5c-9.097,0-16.5-7.401-16.5-16.5 c0-9.097,7.403-16.5,16.5-16.5c9.099,0,16.5,7.403,16.5,16.5C48.5,34.099,41.099,41.5,32,41.5z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "_dlv",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.9,35.3 47.5,35.3 48.2,30.6 52,30.6 55.9,34.6 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,32.1c1.1,0,2.1-0.9,2.1-2.1c0-1.1-0.9-2.1-2.1-2.1H4.9c-1.1,0-2.1,0.9-2.1,2.1c0,1.1,0.9,2.1,2.1,2.1H18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,39.7l0.8-6.4c0-1.4-0.3-2.2-0.8-2.7l-4.8-4.8c-1.2-1.4-2.2-2.5-3.8-2.5h-7.8l0.9-7.7v-0.1c0-1.2-0.8-2.3-2-2.6H13.6 c-1,0.2-2,0.9-2.2,2l-0.8,6H7.5c-1.1,0-2.1,0.9-2.1,2.1c0,1.1,0.9,2.1,2.1,2.1h13.4c1.1,0,2.1-0.9,2.1-2.1c0-1.1-0.9-2.1-2.1-2.1 h-5.1l0.4-2.8h25.2l-3.5,24.5H24c-1.1-1.2-2.7-1.9-4.4-1.9c-1.8,0-3.3,0.8-4.4,1.9h-2.5l0.6-3.5h1.5c1.1,0,2.1-0.9,2.1-2.1 c0-1.1-0.9-2.1-2.1-2.1H2.1C0.9,35.1,0,36,0,37.1c0,1.1,0.9,2.1,2.1,2.1h6l-0.9,6.1c0,1.3,1,2.4,2.3,2.6h4.1c0.4,3,3,5.2,6.1,5.2 s5.7-2.3,6.1-5.2h19.8c0.4,3,3,5.2,6.1,5.2s5.7-2.3,6.1-5.2h1.6c1.2,0,2.2-0.7,2.5-1.9l0.2-2.5c-0.8-0.2-1.2-0.7-1.4-1.7 C60.4,41,61.3,39.7,62.4,39.7z M19.5,50c-1.7,0-3.1-1.3-3.1-3.1c0-1.7,1.3-3.1,3.1-3.1c1.7,0,3.1,1.3,3.1,3.1 C22.6,48.6,21.3,50,19.5,50z M51.6,50c-1.7,0-3.1-1.3-3.1-3.1c0-1.7,1.3-3.1,3.1-3.1c1.7,0,3.1,1.3,3.1,3.1 C54.7,48.6,53.3,50,51.6,50z M58.2,38.8c0,0-0.8,0.6-1.1,2.1c-0.3,1.2,0.1,2.2,0.8,2.8h-1c-1.1-1.7-3.1-3-5.2-3 c-1.8,0-3.3,0.8-4.4,1.9H43l2.3-15.3h8.1l5.4,5.4L58.2,38.8z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "_cnt",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,50.7c0.2-0.7,0.4-1.3,0.7-2C4.5,39.5,11.2,33,20.2,28.8 c3.9-1.8,8.1-2.9,12.4-3.4c3.2-0.4,6.4-0.3,9.6,0c2.5,0.3,5,0.7,7.4,1.3c0.1,0,0.1,0,0.2,0c0.2-1,0.3-1.9,0.4-2.8 c0.1-0.7,0.4-1.3,1.1-1.5c0.7-0.2,1.3,0,1.8,0.5c3.4,3.4,6.8,6.9,10.2,10.3c0.9,0.9,0.8,2.1-0.3,2.8c-4.2,2.6-8.4,5.3-12.5,8 c-0.3,0.2-0.5,0.3-0.8,0.5c-1.1,0.5-2.4-0.2-2.3-1.5c0.1-1,0.3-1.9,0.4-2.8c0.1-0.3,0.1-0.5,0.1-0.8c0.2-0.5,0-0.6-0.4-0.8 c-3.7-1.3-7.5-2.2-11.5-2.7c-10.7-1.2-20.3,1.4-28.9,7.8c-2.7,1.9-5,4.2-7,6.9C0.2,50.7,0.1,50.7,0,50.7C0,50.8,0,50.7,0,50.7z  M13.5,36.3c0,0,0,0.1,0,0.1c0.1-0.1,0.2-0.1,0.3-0.1c7-3.1,14.4-4.2,22-3.4c4.9,0.5,9.6,1.7,14.3,3.5c1.1,0.4,1.4,1,1.2,2.1 c-0.1,0.5-0.2,1-0.3,1.5c0,0,0.1,0.1,0.1,0.1c3-1.9,6-3.8,8.9-5.7c-2.4-2.4-4.8-4.8-7.2-7.3c-0.1,0.6-0.2,1.1-0.3,1.7 c-0.2,1.2-1,1.8-2.3,1.5c-1-0.3-1.9-0.5-2.9-0.7c-5.2-1.2-10.5-1.6-15.8-0.9c-5.6,0.8-10.7,2.7-15.4,5.8 C15.4,35,14.5,35.7,13.5,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,16.5l-0.7,3.1c-0.8,0.3-1.5,0.8-2,1.4l-1.4-0.7l1.7-7.7h-9.7l-1.9,8 c-0.6,1.8-2.4,2.4-3.8,1.6c-0.6-0.4-2.7-1.2-2.7-1.2s-3.5,1.3-4.7,1.5c-1.2,0.2-2.2-0.9-2.3-2.2l1.7-7.7H17l-3.9,16.6l-5.4,4.1 l5.2-23.3C13.2,8.6,13.9,8,15.4,8l35,0c1.4,0.1,1.7,1.4,2.2,2.3l3.2,6.4c0.2,0.4,0.3,1,0.2,1.5l-0.6,2.5l-0.9-0.6 c-0.7-0.5-1.4-0.7-2.2-0.8L51,16.5z M30.7,16.1c0.5,0,0.9,0.1,1.4,0.4c0.3,0.2,0.7,0.4,1,0.5c0,0,0.8-3.3,1-4.4c-1.4,0-2.8,0-4.2,0 L29,16.5c0.2-0.1,0.4-0.1,0.6-0.2C29.9,16.2,30.3,16.1,30.7,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,46.8c0.7,0.4,1.6,0.9,2.4,1l1.3,0.1L48.5,55c-0.3,1.3-1.1,1.9-2.3,1.9 l-32.9,0c-0.9,0-1.6-0.3-2.1-0.9l-5-7.1l5-3.9l30.7,0l1-4.5l1.2,0.3l0.7,0.2l-0.1,0.7c-0.1,0.4-0.1,0.8-0.1,1.2 c-0.1,1,0.1,1.9,0.6,2.7l-0.5,2l1.2,1.9L46.4,46.8z M15.1,52.4l27.1,0l-2.2-2.9l-27,0L15.1,52.4z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "_cit",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5,58.2c0,0,1.5,0,1.5-1.4c0-1.5-1.5-1.7-1.5-1.7h-0.6V12.8H52v6.8H41.1v35.5h-2.7V11.6h-8v-5c0,0,0.1-1.5-1.5-1.5 c-1.4,0-1.4,1.5-1.4,1.5v5.1h-6.7v43.5h-2.7V24.9H2.8v30.4H1.5c0,0-1.5,0.1-1.5,1.4c0,1.5,1.5,1.5,1.5,1.5H62.5z M14.2,50.7V55l0,0 H6.7v-4.3H14.2z M14.2,47.7H6.7v-4.3h7.5V47.7L14.2,47.7z M14.2,40.4H6.7v-4.2h7.5V40.4L14.2,40.4z M14.2,33H6.7v-4.3h7.5V33 L14.2,33z M24.9,55v-4.3h9.5V55H24.9L24.9,55z M34.4,47.7h-9.5v-4.3h9.5V47.7L34.4,47.7z M34.4,36.1v4.3h-9.5v-4.3H34.4L34.4,36.1z  M34.4,33h-9.5v-4.3h9.5V33L34.4,33z M34.4,25.7h-9.5v-4.3h9.5V25.7L34.4,25.7z M34.4,18.4h-9.5v-2.8h9.5V18.4L34.4,18.4z M49.1,55 h-4v-4.3h4V55L49.1,55z M49.1,47.7h-4v-4.3h3.8l0.2,0.1V47.7L49.1,47.7z M49.1,40.4h-4v-4.3h4V40.4L49.1,40.4z M49.1,33h-4v-4.3h4 V33L49.1,33z M49.1,25.7h-4v-3h4V25.7L49.1,25.7z M57.6,33h-2.5v-4.2h2.5V33L57.6,33z M57.6,36.1v4.3h-2.5v-4.3H57.6L57.6,36.1z  M57.6,43.4v4.3h-2.5v-4.3H57.6L57.6,43.4z M55.1,15.6h2.6v2.9h-2.6V15.6L55.1,15.6z M57.6,21.5v4.2h-2.5v-4.2H57.6L57.6,21.5z  M55.1,55.1v-4.3h2.5v4.3H55.1L55.1,55.1z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "_raj",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1,58.2H2V14.8l9.4-11.9l9.4,12v12.4h2.8V16.9h24.4l0,13.1h4.7L62,41.3l0,2.8 h-1.9V58.2z M9.5,27.2H17V16.9l-5.6-7.5l-5.6,7.5v37.5h3.8V27.2z M29.2,31H13.3v23.4h15.9V31z M27.3,20.7v6.6h5.6v8.4l3.8-5.6h7.5 v-9.4H27.3z M41.4,41.3l-4.7-5.6l-3.8,5.6v13.1h8.4V41.3z M56.4,54.4V44.1H45.1v10.3H56.4z M38.6,32.8l6.6,8.4h13.1l-7.5-8.4H38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,34.7v7.5H25v-7.5H17.9z M22.2,39.4h-1.5v-1.9h1.5V39.4z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "_xls",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4,16.7L49.1,3.6L46.8,1H20.2c-3.6,0-6.5,2.9-6.5,6.5v8.3h4l0-6.7c0-2,1.6-3.6,3.6-3.6l22.8,0v10.8c0,4,3.3,7.3,7.3,7.3 h7.9L59,54.7c0,2-1.6,3.6-3.7,3.6l-34.3,0c-1.8,0-3.3-1.8-3.3-4v-2.7h-4v3.9c0,3.9,2.6,7.2,5.9,7.2l36.9,0c3.6,0,6.5-2.9,6.5-6.5 V19.7L60.4,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,53.7H1v-40h41.8V53.7 M5,49.7h33.8V17.7H5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "33.6,44.2 26.5,44.2 21.7,37.5 16.6,44.2 9.6,44.2 18.4,33.2 11.3,23.5 18.4,23.5 21.7,28.8 25.3,23.5 32.5,23.5  25.1,33.2 33.6,44.2 "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_menu",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_230",
    style: {
      fill: "#FFFFFF"
    },
    stroke: "#161616",
    strokeWidth: 1,
    strokeOpacity: 0.7,
    width: 48,
    height: 48,
    x: 72,
    y: 0
  }), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_empty",
    width: 64,
    height: 64,
    x: 128
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_log",
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 64,
    x: 192
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#D0452D"
    },
    width: 64,
    height: 64,
    x: 320
  }), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#run_",
    width: 32,
    height: 64,
    x: 384,
    y: 0
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calen",
    style: {
      fill: "#FFFFFF"
    },
    stroke: "#161616",
    strokeWidth: 0.8,
    strokeOpacity: 0.7,
    width: 64,
    height: 64,
    x: 444,
    y: -8
  }), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exmark",
    width: 64,
    height: 64,
    x: 512,
    y: -8
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#selec",
    width: 64,
    height: 64,
    x: 576,
    y: -4
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#catal",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 640
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fldr",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 704
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calen",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 768
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    style: {
      fill: "#6748a9"
    },
    width: 40,
    height: 40,
    x: 908,
    y: 12
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ok",
    style: {
      fill: "#6748a9"
    },
    width: 40,
    height: 40,
    x: 972,
    y: 12
  }), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#input_",
    width: 64,
    height: 64,
    x: 0,
    y: 64
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print_",
    width: 64,
    height: 64,
    x: 64,
    y: 64
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#post",
    width: 64,
    height: 64,
    x: 128,
    y: 64
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unpost",
    width: 64,
    height: 64,
    x: 192,
    y: 64
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#add",
    width: 64,
    height: 64,
    x: 256,
    y: 64
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder",
    width: 64,
    height: 64,
    x: 320,
    y: 64
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit",
    width: 64,
    height: 64,
    x: 384,
    y: 64
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#copy",
    width: 64,
    height: 64,
    x: 448,
    y: 64
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#del",
    width: 64,
    height: 64,
    x: 512,
    y: 64
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filt",
    width: 64,
    height: 64,
    x: 576,
    y: 64
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fold",
    width: 64,
    height: 64,
    x: 640,
    y: 64
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unfold",
    width: 64,
    height: 64,
    x: 704,
    y: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#transact_",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 768,
    y: 64
  }), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#check_",
    width: 64,
    height: 64,
    x: 832,
    y: 64
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uncheck_",
    width: 64,
    height: 64,
    x: 896,
    y: 64
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#up_",
    width: 64,
    height: 64,
    x: 960,
    y: 64
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dn_",
    width: 64,
    height: 64,
    x: 1024,
    y: 64
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#del2",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 1088,
    y: 64
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#his_",
    style: {
      fill: "#6748a9"
    },
    width: 64,
    height: 64,
    x: 1152,
    y: 64
  }), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#refr",
    width: 64,
    height: 64,
    x: 1216,
    y: 64
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inf",
    width: 64,
    height: 64,
    x: 1280,
    y: 64
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_op",
    width: 64,
    height: 64,
    x: 0,
    y: 128
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_opd",
    width: 64,
    height: 64,
    x: 0,
    y: 192
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cl",
    width: 64,
    height: 64,
    x: 64,
    y: 128
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cld",
    width: 64,
    height: 64,
    x: 64,
    y: 192
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cf",
    width: 64,
    height: 64,
    x: 128,
    y: 128
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_cfd",
    width: 64,
    height: 64,
    x: 128,
    y: 192
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#user",
    width: 64,
    height: 64,
    x: 192,
    y: 128
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#user_d",
    width: 64,
    height: 64,
    x: 192,
    y: 192
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#goods",
    width: 64,
    height: 64,
    x: 256,
    y: 128
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#goods_d",
    width: 64,
    height: 64,
    x: 256,
    y: 192
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deps",
    width: 64,
    height: 64,
    x: 320,
    y: 128
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#deps_d",
    width: 64,
    height: 64,
    x: 320,
    y: 192
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menu_",
    width: 64,
    height: 64,
    x: 384,
    y: 128
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menu_d",
    width: 64,
    height: 64,
    x: 384,
    y: 192
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print1",
    width: 64,
    height: 64,
    x: 448,
    y: 128
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print1_d",
    width: 64,
    height: 64,
    x: 448,
    y: 192
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print2",
    width: 64,
    height: 64,
    x: 512,
    y: 128
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print2_d",
    width: 64,
    height: 64,
    x: 512,
    y: 192
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#discon",
    width: 64,
    height: 64,
    x: 576,
    y: 128
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#discon_d",
    width: 64,
    height: 64,
    x: 576,
    y: 192
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hall",
    width: 64,
    height: 64,
    x: 640,
    y: 128
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hall_d",
    width: 64,
    height: 64,
    x: 640,
    y: 192
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cotr",
    width: 64,
    height: 64,
    x: 704,
    y: 128
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cotr_d",
    width: 64,
    height: 64,
    x: 704,
    y: 192
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coins",
    width: 64,
    height: 64,
    x: 768,
    y: 128
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coins_d",
    width: 64,
    height: 64,
    x: 768,
    y: 192
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artic",
    width: 64,
    height: 64,
    x: 832,
    y: 128
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artic_d",
    width: 64,
    height: 64,
    x: 832,
    y: 192
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#retur",
    fill: "#EC3455",
    width: 64,
    height: 64,
    x: 896,
    y: 128
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#retur_d",
    width: 64,
    height: 64,
    x: 896,
    y: 192
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_251",
    fill: "#4b388a",
    width: 64,
    height: 64,
    x: 960,
    y: 128
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_251",
    fill: "#6748a9aa",
    width: 64,
    height: 64,
    x: 960,
    y: 192
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#D0452D",
    width: 48,
    height: 48,
    x: 961,
    y: 208
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_602",
    fill: "#4b388a",
    width: 64,
    height: 64,
    x: 1024,
    y: 128
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_602",
    fill: "#6748a9aa",
    width: 64,
    height: 64,
    x: 1024,
    y: 192
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#D0452D",
    width: 48,
    height: 48,
    x: 1024,
    y: 208
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_604",
    fill: "#4b388a",
    width: 64,
    height: 64,
    x: 1088,
    y: 128
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_604",
    fill: "#6748a9aa",
    width: 64,
    height: 64,
    x: 1088,
    y: 192
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#D0452D",
    width: 48,
    height: 48,
    x: 1088,
    y: 208
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_a_op",
    width: 64,
    height: 64,
    x: 1152,
    y: 128
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#folder_a_opd",
    width: 64,
    height: 64,
    x: 1152,
    y: 192
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#termi",
    fill: "#4b388a",
    width: 64,
    height: 64,
    x: 1216,
    y: 128
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#termi",
    fill: "#4b388a",
    width: 64,
    height: 64,
    x: 1216,
    y: 192
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel",
    fill: "#D0452D",
    width: 48,
    height: 48,
    x: 1216,
    y: 208
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doc",
    width: 64,
    height: 64,
    x: 0,
    y: 256
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doc_d",
    width: 64,
    height: 64,
    x: 64,
    y: 256
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doc_p",
    width: 64,
    height: 64,
    x: 128,
    y: 256
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn_95v",
    width: 222,
    height: 64,
    x: 0,
    y: 320
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn_135v",
    width: 315,
    height: 64,
    x: 222,
    y: 320
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn_155v",
    width: 362,
    height: 64,
    x: 537,
    y: 320
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn_185v",
    width: 432,
    height: 64,
    x: 900,
    y: 320
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn_95g",
    width: 222,
    height: 64,
    x: 0,
    y: 384
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_100",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 0,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_101",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 64,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_102",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 128,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_200",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 192,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_202",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 256,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_203",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 320,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_220",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 384,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_230",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 448,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_500",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 512,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_501",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 576,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_502",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 640,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_503",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 704,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_504",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 768,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_600",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 832,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_601",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 896,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_250",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 960,
    y: 448
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_103",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 0,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_300",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 64,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_104",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 128,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_400",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 192,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_401",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 256,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_402",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 320,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_201",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 384,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_505",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 448,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_506",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 512,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_951",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 576,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_952",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 640,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_953",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 704,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_954",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 768,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_602",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 832,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_603",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 896,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_251",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 960,
    y: 512
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_955",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 0,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_956",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 64,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_qr",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 128,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b_958",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 192,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_loc",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 256,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_dlv",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 320,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_cnt",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 384,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_cit",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 448,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_raj",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 512,
    y: 576
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_xls",
    style: {
      fill: "#6940bf"
    },
    width: 64,
    height: 64,
    x: 576,
    y: 576
  }), _view || (_view = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu",
    viewBox: "0 0 64 64"
  })), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "rep",
    viewBox: "64 0 64 64"
  })), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "empty",
    viewBox: "128 0 64 64"
  })), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "log",
    viewBox: "192 0 64 64"
  })), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "dlt",
    viewBox: "320 0 64 64"
  })), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "run",
    viewBox: "384 0 32 64"
  })), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "cal_w",
    viewBox: "448 0 64 64"
  })), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "mark",
    viewBox: "512 0 64 64"
  })), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "sel",
    viewBox: "576 0 64 64"
  })), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "cat",
    viewBox: "640 0 64 64"
  })), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "fld",
    viewBox: "704 0 64 64"
  })), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "cal",
    viewBox: "768 0 64 64"
  })), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "canBut",
    viewBox: "896 0 64 64"
  })), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "okBut",
    viewBox: "960 0 64 64"
  })), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "inpBut",
    viewBox: "0 64 64 64"
  })), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "prnBut",
    viewBox: "64 64 64 64"
  })), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "pstBut",
    viewBox: "128 64 64 64"
  })), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "unpBut",
    viewBox: "192 64 64 64"
  })), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "addBut",
    viewBox: "256 64 64 64"
  })), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "fldBut",
    viewBox: "320 64 64 64"
  })), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "editBut",
    viewBox: "384 64 64 64"
  })), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "copyBut",
    viewBox: "448 64 64 64"
  })), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "delBut",
    viewBox: "512 64 64 64"
  })), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "filtBut",
    viewBox: "576 64 64 64"
  })), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "foldBut",
    viewBox: "640 64 64 64"
  })), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "unfoldBut",
    viewBox: "704 64 64 64"
  })), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "postBut",
    viewBox: "768 64 64 64"
  })), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "checkBut",
    viewBox: "832 64 64 64"
  })), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "unchckBut",
    viewBox: "896 64 64 64"
  })), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "upBut",
    viewBox: "960 64 64 64"
  })), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "dnBut",
    viewBox: "1024 64 64 64"
  })), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "remBut",
    viewBox: "1088 64 64 64"
  })), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "hisBut",
    viewBox: "1152 64 64 64"
  })), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "refBut",
    viewBox: "1216 64 64 64"
  })), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "info",
    viewBox: "1280 64 64 64"
  })), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderO",
    viewBox: "0 128 64 64"
  })), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderODel",
    viewBox: "0 192 64 64"
  })), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderC",
    viewBox: "64 128 64 64"
  })), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderCDel",
    viewBox: "64 192 64 64"
  })), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderF",
    viewBox: "128 128 64 64"
  })), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderFDel",
    viewBox: "128 192 64 64"
  })), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catUser",
    viewBox: "192 128 64 64"
  })), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catUserDel",
    viewBox: "192 192 64 64"
  })), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catGoods",
    viewBox: "256 128 64 64"
  })), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catGoodsDel",
    viewBox: "256 192 64 64"
  })), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catDeps",
    viewBox: "320 128 64 64"
  })), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catDepsDel",
    viewBox: "320 192 64 64"
  })), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catMenu",
    viewBox: "384 128 64 64"
  })), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catMenuDel",
    viewBox: "384 192 64 64"
  })), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint1",
    viewBox: "448 128 64 64"
  })), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint1Del",
    viewBox: "448 192 64 64"
  })), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint2",
    viewBox: "448 128 64 64"
  })), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint2Del",
    viewBox: "448 192 64 64"
  })), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint3",
    viewBox: "448 128 64 64"
  })), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint3Del",
    viewBox: "448 192 64 64"
  })), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint4",
    viewBox: "512 128 64 64"
  })), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint4Del",
    viewBox: "512 192 64 64"
  })), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint5",
    viewBox: "512 128 64 64"
  })), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint5Del",
    viewBox: "512 192 64 64"
  })), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catDiscont",
    viewBox: "576 128 64 64"
  })), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catDiscontDel",
    viewBox: "576 192 64 64"
  })), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catHalls",
    viewBox: "640 128 64 64"
  })), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catHallsDel",
    viewBox: "640 192 64 64"
  })), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catContr",
    viewBox: "704 128 64 64"
  })), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catContrDel",
    viewBox: "704 192 64 64"
  })), _view66 || (_view66 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catCash",
    viewBox: "768 128 64 64"
  })), _view67 || (_view67 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catCashDel",
    viewBox: "768 192 64 64"
  })), _view68 || (_view68 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catArts",
    viewBox: "832 128 64 64"
  })), _view69 || (_view69 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catArtsDel",
    viewBox: "832 192 64 64"
  })), _view70 || (_view70 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catReas",
    viewBox: "896 128 64 64"
  })), _view71 || (_view71 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catReasDel",
    viewBox: "896 192 64 64"
  })), _view72 || (_view72 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catCert",
    viewBox: "960 128 64 64"
  })), _view73 || (_view73 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catCertDel",
    viewBox: "960 192 64 64"
  })), _view74 || (_view74 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPos",
    viewBox: "1024 128 64 64"
  })), _view75 || (_view75 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPosDel",
    viewBox: "1024 192 64 64"
  })), _view76 || (_view76 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catEmp",
    viewBox: "1088 128 64 64"
  })), _view77 || (_view77 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catEmpDel",
    viewBox: "1088 192 64 64"
  })), _view78 || (_view78 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderAO",
    viewBox: "1152 128 64 64"
  })), _view79 || (_view79 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catFolderAODel",
    viewBox: "1152 192 64 64"
  })), _view80 || (_view80 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint7",
    viewBox: "1216 128 64 64"
  })), _view81 || (_view81 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "catPrint7Del",
    viewBox: "1216 192 64 64"
  })), _view82 || (_view82 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "docum",
    viewBox: "0 256 64 64"
  })), _view83 || (_view83 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "documDel",
    viewBox: "64 256 64 64"
  })), _view84 || (_view84 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "documPst",
    viewBox: "128 256 64 64"
  })), _view85 || (_view85 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn95v",
    viewBox: "0 320 222 64"
  })), _view86 || (_view86 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn135v",
    viewBox: "222 320 315 64"
  })), _view87 || (_view87 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn155v",
    viewBox: "537 320 362 64"
  })), _view88 || (_view88 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn185v",
    viewBox: "900 320 432 64"
  })), _view89 || (_view89 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn95g",
    viewBox: "0 384 222 64"
  })), _view90 || (_view90 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b100",
    viewBox: "0 448 64 64"
  })), _view91 || (_view91 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b101",
    viewBox: "64 448 64 64"
  })), _view92 || (_view92 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b102",
    viewBox: "128 448 64 64"
  })), _view93 || (_view93 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b103",
    viewBox: "0 512 64 64"
  })), _view94 || (_view94 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b104",
    viewBox: "128 512 64 64"
  })), _view95 || (_view95 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b200",
    viewBox: "192 448 64 64"
  })), _view96 || (_view96 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b201",
    viewBox: "384 512 64 64"
  })), _view97 || (_view97 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b202",
    viewBox: "256 448 64 64"
  })), _view98 || (_view98 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b203",
    viewBox: "320 448 64 64"
  })), _view99 || (_view99 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b220",
    viewBox: "384 448 64 64"
  })), _view100 || (_view100 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b230",
    viewBox: "448 448 64 64"
  })), _view101 || (_view101 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b300",
    viewBox: "64 512 64 64"
  })), _view102 || (_view102 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b400",
    viewBox: "192 512 64 64"
  })), _view103 || (_view103 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b401",
    viewBox: "256 512 64 64"
  })), _view104 || (_view104 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b402",
    viewBox: "320 512 64 64"
  })), _view105 || (_view105 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b500",
    viewBox: "512 448 64 64"
  })), _view106 || (_view106 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b501",
    viewBox: "576 448 64 64"
  })), _view107 || (_view107 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b502",
    viewBox: "640 448 64 64"
  })), _view108 || (_view108 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b503",
    viewBox: "704 448 64 64"
  })), _view109 || (_view109 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b504",
    viewBox: "768 448 64 64"
  })), _view110 || (_view110 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b505",
    viewBox: "448 512 64 64"
  })), _view111 || (_view111 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b506",
    viewBox: "512 512 64 64"
  })), _view112 || (_view112 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b951",
    viewBox: "576 512 64 64"
  })), _view113 || (_view113 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b952",
    viewBox: "640 512 64 64"
  })), _view114 || (_view114 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b953",
    viewBox: "704 512 64 64"
  })), _view115 || (_view115 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b954",
    viewBox: "768 512 64 64"
  })), _view116 || (_view116 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b955",
    viewBox: "0 576 64 64"
  })), _view117 || (_view117 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b956",
    viewBox: "64 576 64 64"
  })), _view118 || (_view118 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b957",
    viewBox: "127 576 64 64"
  })), _view119 || (_view119 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b600",
    viewBox: "832 448 64 64"
  })), _view120 || (_view120 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b601",
    viewBox: "896 448 64 64"
  })), _view121 || (_view121 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b602",
    viewBox: "832 512 64 64"
  })), _view122 || (_view122 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b603",
    viewBox: "896 512 64 64"
  })), _view123 || (_view123 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b250",
    viewBox: "960 448 64 64"
  })), _view124 || (_view124 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b251",
    viewBox: "960 512 64 64"
  })), _view125 || (_view125 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b958",
    viewBox: "192 576 64 64"
  })), _view126 || (_view126 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b225",
    viewBox: "256 576 64 64"
  })), _view127 || (_view127 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b700",
    viewBox: "320 576 64 64"
  })), _view128 || (_view128 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b284",
    viewBox: "384 576 64 64"
  })), _view129 || (_view129 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b281",
    viewBox: "448 576 64 64"
  })), _view130 || (_view130 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "b282",
    viewBox: "512 576 64 64"
  })), _view131 || (_view131 = /*#__PURE__*/React.createElement("view", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "xlsx",
    viewBox: "576 576 64 64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.d6463e7b0b53243bf9d5fc48db4ffa12.svg";
export { ForwardRef as ReactComponent };